const $c43e58f8644a8863$var$isObject = (value)=>typeof value === 'object' && value !== null;
// Customized for this use-case
const $c43e58f8644a8863$var$isObjectCustom = (value)=>$c43e58f8644a8863$var$isObject(value) && !(value instanceof RegExp) && !(value instanceof Error) && !(value instanceof Date);
const $c43e58f8644a8863$export$1907644b6cb89d54 = Symbol('mapObjectSkip');
const $c43e58f8644a8863$var$_mapObject = (object, mapper, options, isSeen = new WeakMap())=>{
    options = {
        deep: false,
        target: {},
        ...options
    };
    if (isSeen.has(object)) return isSeen.get(object);
    isSeen.set(object, options.target);
    const { target: target } = options;
    delete options.target;
    const mapArray = (array)=>array.map((element)=>$c43e58f8644a8863$var$isObjectCustom(element) ? $c43e58f8644a8863$var$_mapObject(element, mapper, options, isSeen) : element);
    if (Array.isArray(object)) return mapArray(object);
    for (const [key, value] of Object.entries(object)){
        const mapResult = mapper(key, value, object);
        if (mapResult === $c43e58f8644a8863$export$1907644b6cb89d54) continue;
        let [newKey, newValue, { shouldRecurse: shouldRecurse = true } = {}] = mapResult;
        // Drop `__proto__` keys.
        if (newKey === '__proto__') continue;
        if (options.deep && shouldRecurse && $c43e58f8644a8863$var$isObjectCustom(newValue)) newValue = Array.isArray(newValue) ? mapArray(newValue) : $c43e58f8644a8863$var$_mapObject(newValue, mapper, options, isSeen);
        target[newKey] = newValue;
    }
    return target;
};
function $c43e58f8644a8863$export$2e2bcd8739ae039(object, mapper, options) {
    if (!$c43e58f8644a8863$var$isObject(object)) throw new TypeError(`Expected an object, got \`${object}\` (${typeof object})`);
    return $c43e58f8644a8863$var$_mapObject(object, mapper, options);
}


const $06daed6f3dfa6bfa$var$UPPERCASE = /[\p{Lu}]/u;
const $06daed6f3dfa6bfa$var$LOWERCASE = /[\p{Ll}]/u;
const $06daed6f3dfa6bfa$var$LEADING_CAPITAL = /^[\p{Lu}](?![\p{Lu}])/gu;
const $06daed6f3dfa6bfa$var$IDENTIFIER = /([\p{Alpha}\p{N}_]|$)/u;
const $06daed6f3dfa6bfa$var$SEPARATORS = /[_.\- ]+/;
const $06daed6f3dfa6bfa$var$LEADING_SEPARATORS = new RegExp('^' + $06daed6f3dfa6bfa$var$SEPARATORS.source);
const $06daed6f3dfa6bfa$var$SEPARATORS_AND_IDENTIFIER = new RegExp($06daed6f3dfa6bfa$var$SEPARATORS.source + $06daed6f3dfa6bfa$var$IDENTIFIER.source, 'gu');
const $06daed6f3dfa6bfa$var$NUMBERS_AND_IDENTIFIER = new RegExp('\\d+' + $06daed6f3dfa6bfa$var$IDENTIFIER.source, 'gu');
const $06daed6f3dfa6bfa$var$preserveCamelCase = (string, toLowerCase, toUpperCase, preserveConsecutiveUppercase)=>{
    let isLastCharLower = false;
    let isLastCharUpper = false;
    let isLastLastCharUpper = false;
    let isLastLastCharPreserved = false;
    for(let index = 0; index < string.length; index++){
        const character = string[index];
        isLastLastCharPreserved = index > 2 ? string[index - 3] === '-' : true;
        if (isLastCharLower && $06daed6f3dfa6bfa$var$UPPERCASE.test(character)) {
            string = string.slice(0, index) + '-' + string.slice(index);
            isLastCharLower = false;
            isLastLastCharUpper = isLastCharUpper;
            isLastCharUpper = true;
            index++;
        } else if (isLastCharUpper && isLastLastCharUpper && $06daed6f3dfa6bfa$var$LOWERCASE.test(character) && (!isLastLastCharPreserved || preserveConsecutiveUppercase)) {
            string = string.slice(0, index - 1) + '-' + string.slice(index - 1);
            isLastLastCharUpper = isLastCharUpper;
            isLastCharUpper = false;
            isLastCharLower = true;
        } else {
            isLastCharLower = toLowerCase(character) === character && toUpperCase(character) !== character;
            isLastLastCharUpper = isLastCharUpper;
            isLastCharUpper = toUpperCase(character) === character && toLowerCase(character) !== character;
        }
    }
    return string;
};
const $06daed6f3dfa6bfa$var$preserveConsecutiveUppercase = (input, toLowerCase)=>{
    $06daed6f3dfa6bfa$var$LEADING_CAPITAL.lastIndex = 0;
    return input.replaceAll($06daed6f3dfa6bfa$var$LEADING_CAPITAL, (match)=>toLowerCase(match));
};
const $06daed6f3dfa6bfa$var$postProcess = (input, toUpperCase)=>{
    $06daed6f3dfa6bfa$var$SEPARATORS_AND_IDENTIFIER.lastIndex = 0;
    $06daed6f3dfa6bfa$var$NUMBERS_AND_IDENTIFIER.lastIndex = 0;
    return input.replaceAll($06daed6f3dfa6bfa$var$NUMBERS_AND_IDENTIFIER, (match, pattern, offset)=>[
            '_',
            '-'
        ].includes(input.charAt(offset + match.length)) ? match : toUpperCase(match)).replaceAll($06daed6f3dfa6bfa$var$SEPARATORS_AND_IDENTIFIER, (_, identifier)=>toUpperCase(identifier));
};
function $06daed6f3dfa6bfa$export$2e2bcd8739ae039(input, options) {
    if (!(typeof input === 'string' || Array.isArray(input))) throw new TypeError('Expected the input to be `string | string[]`');
    options = {
        pascalCase: false,
        preserveConsecutiveUppercase: false,
        ...options
    };
    if (Array.isArray(input)) input = input.map((x)=>x.trim()).filter((x)=>x.length).join('-');
    else input = input.trim();
    if (input.length === 0) return '';
    const toLowerCase = options.locale === false ? (string)=>string.toLowerCase() : (string)=>string.toLocaleLowerCase(options.locale);
    const toUpperCase = options.locale === false ? (string)=>string.toUpperCase() : (string)=>string.toLocaleUpperCase(options.locale);
    if (input.length === 1) {
        if ($06daed6f3dfa6bfa$var$SEPARATORS.test(input)) return '';
        return options.pascalCase ? toUpperCase(input) : toLowerCase(input);
    }
    const hasUpperCase = input !== toLowerCase(input);
    if (hasUpperCase) input = $06daed6f3dfa6bfa$var$preserveCamelCase(input, toLowerCase, toUpperCase, options.preserveConsecutiveUppercase);
    input = input.replace($06daed6f3dfa6bfa$var$LEADING_SEPARATORS, '');
    input = options.preserveConsecutiveUppercase ? $06daed6f3dfa6bfa$var$preserveConsecutiveUppercase(input, toLowerCase) : toLowerCase(input);
    if (options.pascalCase) input = toUpperCase(input.charAt(0)) + input.slice(1);
    return $06daed6f3dfa6bfa$var$postProcess(input, toUpperCase);
}


class $97bce4c75e3fbef2$export$2e2bcd8739ae039 extends Map {
    constructor(options = {}){
        super();
        if (!(options.maxSize && options.maxSize > 0)) throw new TypeError('`maxSize` must be a number greater than 0');
        if (typeof options.maxAge === 'number' && options.maxAge === 0) throw new TypeError('`maxAge` must be a number greater than 0');
        // TODO: Use private class fields when ESLint supports them.
        this.maxSize = options.maxSize;
        this.maxAge = options.maxAge || Number.POSITIVE_INFINITY;
        this.onEviction = options.onEviction;
        this.cache = new Map();
        this.oldCache = new Map();
        this._size = 0;
    }
    // TODO: Use private class methods when targeting Node.js 16.
    _emitEvictions(cache) {
        if (typeof this.onEviction !== 'function') return;
        for (const [key, item] of cache)this.onEviction(key, item.value);
    }
    _deleteIfExpired(key, item) {
        if (typeof item.expiry === 'number' && item.expiry <= Date.now()) {
            if (typeof this.onEviction === 'function') this.onEviction(key, item.value);
            return this.delete(key);
        }
        return false;
    }
    _getOrDeleteIfExpired(key, item) {
        const deleted = this._deleteIfExpired(key, item);
        if (deleted === false) return item.value;
    }
    _getItemValue(key, item) {
        return item.expiry ? this._getOrDeleteIfExpired(key, item) : item.value;
    }
    _peek(key, cache) {
        const item = cache.get(key);
        return this._getItemValue(key, item);
    }
    _set(key, value) {
        this.cache.set(key, value);
        this._size++;
        if (this._size >= this.maxSize) {
            this._size = 0;
            this._emitEvictions(this.oldCache);
            this.oldCache = this.cache;
            this.cache = new Map();
        }
    }
    _moveToRecent(key, item) {
        this.oldCache.delete(key);
        this._set(key, item);
    }
    *_entriesAscending() {
        for (const item of this.oldCache){
            const [key, value] = item;
            if (!this.cache.has(key)) {
                const deleted = this._deleteIfExpired(key, value);
                if (deleted === false) yield item;
            }
        }
        for (const item of this.cache){
            const [key, value] = item;
            const deleted = this._deleteIfExpired(key, value);
            if (deleted === false) yield item;
        }
    }
    get(key) {
        if (this.cache.has(key)) {
            const item = this.cache.get(key);
            return this._getItemValue(key, item);
        }
        if (this.oldCache.has(key)) {
            const item = this.oldCache.get(key);
            if (this._deleteIfExpired(key, item) === false) {
                this._moveToRecent(key, item);
                return item.value;
            }
        }
    }
    set(key, value, { maxAge: maxAge = this.maxAge } = {}) {
        const expiry = typeof maxAge === 'number' && maxAge !== Number.POSITIVE_INFINITY ? Date.now() + maxAge : undefined;
        if (this.cache.has(key)) this.cache.set(key, {
            value: value,
            expiry: expiry
        });
        else this._set(key, {
            value: value,
            expiry: expiry
        });
        return this;
    }
    has(key) {
        if (this.cache.has(key)) return !this._deleteIfExpired(key, this.cache.get(key));
        if (this.oldCache.has(key)) return !this._deleteIfExpired(key, this.oldCache.get(key));
        return false;
    }
    peek(key) {
        if (this.cache.has(key)) return this._peek(key, this.cache);
        if (this.oldCache.has(key)) return this._peek(key, this.oldCache);
    }
    delete(key) {
        const deleted = this.cache.delete(key);
        if (deleted) this._size--;
        return this.oldCache.delete(key) || deleted;
    }
    clear() {
        this.cache.clear();
        this.oldCache.clear();
        this._size = 0;
    }
    resize(newSize) {
        if (!(newSize && newSize > 0)) throw new TypeError('`maxSize` must be a number greater than 0');
        const items = [
            ...this._entriesAscending()
        ];
        const removeCount = items.length - newSize;
        if (removeCount < 0) {
            this.cache = new Map(items);
            this.oldCache = new Map();
            this._size = items.length;
        } else {
            if (removeCount > 0) this._emitEvictions(items.slice(0, removeCount));
            this.oldCache = new Map(items.slice(removeCount));
            this.cache = new Map();
            this._size = 0;
        }
        this.maxSize = newSize;
    }
    *keys() {
        for (const [key] of this)yield key;
    }
    *values() {
        for (const [, value] of this)yield value;
    }
    *[Symbol.iterator]() {
        for (const item of this.cache){
            const [key, value] = item;
            const deleted = this._deleteIfExpired(key, value);
            if (deleted === false) yield [
                key,
                value.value
            ];
        }
        for (const item of this.oldCache){
            const [key, value] = item;
            if (!this.cache.has(key)) {
                const deleted = this._deleteIfExpired(key, value);
                if (deleted === false) yield [
                    key,
                    value.value
                ];
            }
        }
    }
    *entriesDescending() {
        let items = [
            ...this.cache
        ];
        for(let i = items.length - 1; i >= 0; --i){
            const item = items[i];
            const [key, value] = item;
            const deleted = this._deleteIfExpired(key, value);
            if (deleted === false) yield [
                key,
                value.value
            ];
        }
        items = [
            ...this.oldCache
        ];
        for(let i = items.length - 1; i >= 0; --i){
            const item = items[i];
            const [key, value] = item;
            if (!this.cache.has(key)) {
                const deleted = this._deleteIfExpired(key, value);
                if (deleted === false) yield [
                    key,
                    value.value
                ];
            }
        }
    }
    *entriesAscending() {
        for (const [key, value] of this._entriesAscending())yield [
            key,
            value.value
        ];
    }
    get size() {
        if (!this._size) return this.oldCache.size;
        let oldCacheSize = 0;
        for (const key of this.oldCache.keys())if (!this.cache.has(key)) oldCacheSize++;
        return Math.min(this._size + oldCacheSize, this.maxSize);
    }
    entries() {
        return this.entriesAscending();
    }
    forEach(callbackFunction, thisArgument = this) {
        for (const [key, value] of this.entriesAscending())callbackFunction.call(thisArgument, value, key, this);
    }
    get [Symbol.toStringTag]() {
        return JSON.stringify([
            ...this.entriesAscending()
        ]);
    }
}


const $3ef0a256286d58d5$var$has = (array, key)=>array.some((element)=>{
        if (typeof element === 'string') return element === key;
        element.lastIndex = 0;
        return element.test(key);
    });
const $3ef0a256286d58d5$var$cache = new (0, $97bce4c75e3fbef2$export$2e2bcd8739ae039)({
    maxSize: 100000
});
// Reproduces behavior from `map-obj`.
const $3ef0a256286d58d5$var$isObject = (value)=>typeof value === 'object' && value !== null && !(value instanceof RegExp) && !(value instanceof Error) && !(value instanceof Date);
const $3ef0a256286d58d5$var$transform = (input, options = {})=>{
    if (!$3ef0a256286d58d5$var$isObject(input)) return input;
    const { exclude: exclude, pascalCase: pascalCase = false, stopPaths: stopPaths, deep: deep = false, preserveConsecutiveUppercase: preserveConsecutiveUppercase = false } = options;
    const stopPathsSet = new Set(stopPaths);
    const makeMapper = (parentPath)=>(key, value)=>{
            if (deep && $3ef0a256286d58d5$var$isObject(value)) {
                const path = parentPath === undefined ? key : `${parentPath}.${key}`;
                if (!stopPathsSet.has(path)) value = (0, $c43e58f8644a8863$export$2e2bcd8739ae039)(value, makeMapper(path));
            }
            if (!(exclude && $3ef0a256286d58d5$var$has(exclude, key))) {
                const cacheKey = pascalCase ? `${key}_` : key;
                if ($3ef0a256286d58d5$var$cache.has(cacheKey)) key = $3ef0a256286d58d5$var$cache.get(cacheKey);
                else {
                    const returnValue = (0, $06daed6f3dfa6bfa$export$2e2bcd8739ae039)(key, {
                        pascalCase: pascalCase,
                        locale: false,
                        preserveConsecutiveUppercase: preserveConsecutiveUppercase
                    });
                    if (key.length < 100) $3ef0a256286d58d5$var$cache.set(cacheKey, returnValue);
                    key = returnValue;
                }
            }
            return [
                key,
                value
            ];
        };
    return (0, $c43e58f8644a8863$export$2e2bcd8739ae039)(input, makeMapper(undefined));
};
function $3ef0a256286d58d5$export$2e2bcd8739ae039(input, options) {
    if (Array.isArray(input)) return Object.keys(input).map((key)=>$3ef0a256286d58d5$var$transform(input[key], options));
    return $3ef0a256286d58d5$var$transform(input, options);
}


/**
 * @overview Constants for Logto. Synchronized with `@logto/core-kit` package at hash `081094d`.
 */ /** Scopes that reserved by Logto, which will be added to the auth request automatically. */ var $c647641c72d4ae96$export$1d2e82cebfd4b08;
(function(ReservedScope) {
    ReservedScope["OpenId"] = "openid";
    ReservedScope["OfflineAccess"] = "offline_access";
})($c647641c72d4ae96$export$1d2e82cebfd4b08 || ($c647641c72d4ae96$export$1d2e82cebfd4b08 = {}));
/** Resources that reserved by Logto, which cannot be defined by users. */ var $c647641c72d4ae96$export$36ba08a8e14b2df6;
(function(ReservedResource) {
    /**
     * The resource for organization template per RFC 0001.
     *
     * @see {@link https://github.com/logto-io/rfcs | RFC 0001} for more details.
     */ ReservedResource["Organization"] = "urn:logto:resource:organizations";
})($c647641c72d4ae96$export$36ba08a8e14b2df6 || ($c647641c72d4ae96$export$36ba08a8e14b2df6 = {}));
/**
 * Scopes for ID Token and Userinfo Endpoint.
 */ var $c647641c72d4ae96$export$4b02c5b431f6eb78;
(function(UserScope) {
    /**
     * Scope for basic user info.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Profile"] = "profile";
    /**
     * Scope for user email address.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Email"] = "email";
    /**
     * Scope for user phone number.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Phone"] = "phone";
    /**
     * Scope for user address.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Address"] = "address";
    /**
     * Scope for user's custom data.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["CustomData"] = "custom_data";
    /**
     * Scope for user's social identity details.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Identities"] = "identities";
    /**
     * Scope for user's roles.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Roles"] = "roles";
    /**
     * Scope for user's organization IDs and perform organization token grant per [RFC 0001](https://github.com/logto-io/rfcs).
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Organizations"] = "urn:logto:scope:organizations";
    /**
     * Scope for user's organization roles per [RFC 0001](https://github.com/logto-io/rfcs).
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["OrganizationRoles"] = "urn:logto:scope:organization_roles";
})($c647641c72d4ae96$export$4b02c5b431f6eb78 || ($c647641c72d4ae96$export$4b02c5b431f6eb78 = {}));
/**
 * Mapped claims that ID Token includes.
 */ const $c647641c72d4ae96$export$f57bb8dda2a18319 = Object.freeze({
    [$c647641c72d4ae96$export$4b02c5b431f6eb78.Profile]: [
        'name',
        'picture',
        'username'
    ],
    [$c647641c72d4ae96$export$4b02c5b431f6eb78.Email]: [
        'email',
        'email_verified'
    ],
    [$c647641c72d4ae96$export$4b02c5b431f6eb78.Phone]: [
        'phone_number',
        'phone_number_verified'
    ],
    [$c647641c72d4ae96$export$4b02c5b431f6eb78.Address]: [],
    [$c647641c72d4ae96$export$4b02c5b431f6eb78.Roles]: [
        'roles'
    ],
    [$c647641c72d4ae96$export$4b02c5b431f6eb78.Organizations]: [
        'organizations'
    ],
    [$c647641c72d4ae96$export$4b02c5b431f6eb78.OrganizationRoles]: [
        'organization_roles'
    ],
    [$c647641c72d4ae96$export$4b02c5b431f6eb78.CustomData]: [],
    [$c647641c72d4ae96$export$4b02c5b431f6eb78.Identities]: []
});
/**
 * Additional claims that Userinfo Endpoint returns.
 */ const $c647641c72d4ae96$export$c11d5a3385aa71dd = Object.freeze({
    [$c647641c72d4ae96$export$4b02c5b431f6eb78.Profile]: [],
    [$c647641c72d4ae96$export$4b02c5b431f6eb78.Email]: [],
    [$c647641c72d4ae96$export$4b02c5b431f6eb78.Phone]: [],
    [$c647641c72d4ae96$export$4b02c5b431f6eb78.Address]: [],
    [$c647641c72d4ae96$export$4b02c5b431f6eb78.Roles]: [],
    [$c647641c72d4ae96$export$4b02c5b431f6eb78.Organizations]: [],
    [$c647641c72d4ae96$export$4b02c5b431f6eb78.OrganizationRoles]: [],
    [$c647641c72d4ae96$export$4b02c5b431f6eb78.CustomData]: [
        'custom_data'
    ],
    [$c647641c72d4ae96$export$4b02c5b431f6eb78.Identities]: [
        'identities'
    ]
});
const $c647641c72d4ae96$export$6c46daeabb0176f9 = Object.freeze(// Hard to infer type directly, use `as` for a workaround.
// eslint-disable-next-line no-restricted-syntax
Object.fromEntries(Object.values($c647641c72d4ae96$export$4b02c5b431f6eb78).map((current)=>[
        current,
        [
            ...$c647641c72d4ae96$export$f57bb8dda2a18319[current],
            ...$c647641c72d4ae96$export$c11d5a3385aa71dd[current]
        ]
    ])));
/**
 * The prefix of the URN (Uniform Resource Name) for the organization in Logto.
 *
 * @example
 * ```
 * urn:logto:organization:123 // organization with ID 123
 * ```
 * @see {@link https://en.wikipedia.org/wiki/Uniform_Resource_Name | Uniform Resource Name}
 */ const $c647641c72d4ae96$export$fc38cc6da79faa5c = 'urn:logto:organization:';
/**
 * Build the URN (Uniform Resource Name) for the organization in Logto.
 *
 * @param organizationId The ID of the organization.
 * @returns The URN for the organization.
 * @see {@link organizationUrnPrefix} for the prefix of the URN.
 * @example
 * ```ts
 * buildOrganizationUrn('1') // returns 'urn:logto:organization:1'
 * ```
 */ const $c647641c72d4ae96$export$22667c0b6b2d7fac = (organizationId)=>`${$c647641c72d4ae96$export$fc38cc6da79faa5c}${organizationId}`;
/**
 * Get the organization ID from the URN (Uniform Resource Name) for the organization in Logto.
 *
 * @param urn The URN for the organization. Must start with {@link organizationUrnPrefix}.
 * @returns The ID of the organization.
 * @throws {TypeError} If the URN is invalid.
 * @example
 * ```ts
 * getOrganizationIdFromUrn('1') // throws TypeError
 * getOrganizationIdFromUrn('urn:logto:organization:1') // returns '1'
 * ```
 */ const $c647641c72d4ae96$export$a237ae1b02e4e718 = (urn)=>{
    if (!urn.startsWith($c647641c72d4ae96$export$fc38cc6da79faa5c)) throw new TypeError('Invalid organization URN.');
    return urn.slice($c647641c72d4ae96$export$fc38cc6da79faa5c.length);
};


const $16df83338927e1fb$export$e2e108cbe2e4f865 = {
    formUrlEncoded: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
};
var $16df83338927e1fb$export$3f2aafdd1ccae76c;
(function(TokenGrantType) {
    TokenGrantType["AuthorizationCode"] = "authorization_code";
    TokenGrantType["RefreshToken"] = "refresh_token";
})($16df83338927e1fb$export$3f2aafdd1ccae76c || ($16df83338927e1fb$export$3f2aafdd1ccae76c = {}));
var $16df83338927e1fb$export$65f63a8bc3cba53d;
(function(QueryKey) {
    QueryKey["ClientId"] = "client_id";
    QueryKey["Code"] = "code";
    QueryKey["CodeChallenge"] = "code_challenge";
    QueryKey["CodeChallengeMethod"] = "code_challenge_method";
    QueryKey["CodeVerifier"] = "code_verifier";
    QueryKey["Error"] = "error";
    QueryKey["ErrorDescription"] = "error_description";
    QueryKey["GrantType"] = "grant_type";
    QueryKey["IdToken"] = "id_token";
    QueryKey["IdTokenHint"] = "id_token_hint";
    QueryKey["LoginHint"] = "login_hint";
    QueryKey["PostLogoutRedirectUri"] = "post_logout_redirect_uri";
    QueryKey["Prompt"] = "prompt";
    QueryKey["RedirectUri"] = "redirect_uri";
    QueryKey["RefreshToken"] = "refresh_token";
    QueryKey["Resource"] = "resource";
    QueryKey["ResponseType"] = "response_type";
    QueryKey["Scope"] = "scope";
    QueryKey["State"] = "state";
    /** @deprecated */ QueryKey["Token"] = "token";
    /** Need to align with the OIDC extraParams settings in core */ QueryKey["InteractionMode"] = "interaction_mode";
    /** The query key for specifying the organization ID. */ QueryKey["OrganizationId"] = "organization_id";
    QueryKey["FirstScreen"] = "first_screen";
    QueryKey["Identifier"] = "identifier";
    QueryKey["DirectSignIn"] = "direct_sign_in";
    /** @experimental This might change in future development. Please use with caution. */ QueryKey["OneTimeToken"] = "one_time_token";
})($16df83338927e1fb$export$65f63a8bc3cba53d || ($16df83338927e1fb$export$65f63a8bc3cba53d = {}));
/** The prompt parameter to be used for the authorization request. */ var $16df83338927e1fb$export$83716a4aa1642908;
(function(Prompt) {
    Prompt["None"] = "none";
    /**
     * The Authorization Server MUST prompt the End-User for consent
     * before returning information to the Client.
     */ Prompt["Consent"] = "consent";
    /**
     * The Authorization Server MUST prompt the End-User for re-authentication,
     * forcing the user to log in again. Note the there'll be no Refresh Token
     * returned in this case.
     */ Prompt["Login"] = "login";
})($16df83338927e1fb$export$83716a4aa1642908 || ($16df83338927e1fb$export$83716a4aa1642908 = {}));


const $4671b2c4949e30aa$export$684f740cd70532d4 = async ({ clientId: clientId, tokenEndpoint: tokenEndpoint, redirectUri: redirectUri, codeVerifier: codeVerifier, code: code, resource: resource }, requester)=>{
    const parameters = new URLSearchParams();
    parameters.append((0, $16df83338927e1fb$export$65f63a8bc3cba53d).ClientId, clientId);
    parameters.append((0, $16df83338927e1fb$export$65f63a8bc3cba53d).Code, code);
    parameters.append((0, $16df83338927e1fb$export$65f63a8bc3cba53d).CodeVerifier, codeVerifier);
    parameters.append((0, $16df83338927e1fb$export$65f63a8bc3cba53d).RedirectUri, redirectUri);
    parameters.append((0, $16df83338927e1fb$export$65f63a8bc3cba53d).GrantType, (0, $16df83338927e1fb$export$3f2aafdd1ccae76c).AuthorizationCode);
    if (resource) parameters.append((0, $16df83338927e1fb$export$65f63a8bc3cba53d).Resource, resource);
    const snakeCaseCodeTokenResponse = await requester(tokenEndpoint, {
        method: 'POST',
        headers: (0, $16df83338927e1fb$export$e2e108cbe2e4f865).formUrlEncoded,
        body: parameters.toString()
    });
    return (0, $3ef0a256286d58d5$export$2e2bcd8739ae039)(snakeCaseCodeTokenResponse);
};
/**
 * Fetch access token by refresh token using the token endpoint and `refresh_token` grant type.
 * @param params The parameters for fetching access token.
 * @param requester The requester for sending HTTP request.
 * @returns A Promise that resolves to the access token response.
 */ const $4671b2c4949e30aa$export$9909137b467efb8b = async (params, requester)=>{
    const { clientId: clientId, tokenEndpoint: tokenEndpoint, refreshToken: refreshToken, resource: resource, organizationId: organizationId, scopes: scopes } = params;
    const parameters = new URLSearchParams();
    parameters.append((0, $16df83338927e1fb$export$65f63a8bc3cba53d).ClientId, clientId);
    parameters.append((0, $16df83338927e1fb$export$65f63a8bc3cba53d).RefreshToken, refreshToken);
    parameters.append((0, $16df83338927e1fb$export$65f63a8bc3cba53d).GrantType, (0, $16df83338927e1fb$export$3f2aafdd1ccae76c).RefreshToken);
    if (resource) parameters.append((0, $16df83338927e1fb$export$65f63a8bc3cba53d).Resource, resource);
    if (organizationId) parameters.append((0, $16df83338927e1fb$export$65f63a8bc3cba53d).OrganizationId, organizationId);
    if (scopes?.length) parameters.append((0, $16df83338927e1fb$export$65f63a8bc3cba53d).Scope, scopes.join(' '));
    const snakeCaseRefreshTokenTokenResponse = await requester(tokenEndpoint, {
        method: 'POST',
        headers: (0, $16df83338927e1fb$export$e2e108cbe2e4f865).formUrlEncoded,
        body: parameters.toString()
    });
    return (0, $3ef0a256286d58d5$export$2e2bcd8739ae039)(snakeCaseRefreshTokenTokenResponse);
};



const $351109632fb0ed83$export$815bda5ead26b243 = '/oidc/.well-known/openid-configuration';
const $351109632fb0ed83$export$98242d8e822ad11f = async (endpoint, requester)=>(0, $3ef0a256286d58d5$export$2e2bcd8739ae039)(await requester(endpoint));



const $f139cd7b1f3b1db5$export$573f8dbbf6fbef75 = async (revocationEndpoint, clientId, token, requester)=>requester(revocationEndpoint, {
        method: 'POST',
        headers: (0, $16df83338927e1fb$export$e2e108cbe2e4f865).formUrlEncoded,
        body: new URLSearchParams({
            [(0, $16df83338927e1fb$export$65f63a8bc3cba53d).ClientId]: clientId,
            [(0, $16df83338927e1fb$export$65f63a8bc3cba53d).Token]: token
        }).toString()
    });





/**
 * @param originalScopes
 * @return scopes should contain all default scopes (`openid`, `offline_access` and `profile`)
 */ const $b7edcde1a56281b2$export$887ed125f549a57 = (originalScopes)=>{
    const reservedScopes = Object.values((0, $c647641c72d4ae96$export$1d2e82cebfd4b08));
    const uniqueScopes = new Set([
        ...reservedScopes,
        (0, $c647641c72d4ae96$export$4b02c5b431f6eb78).Profile,
        ...originalScopes ?? []
    ]);
    return Array.from(uniqueScopes).join(' ');
};
/**
 * Alias of {@link withReservedScopes}.
 *
 * @deprecated Use {@link withReservedScopes} instead.
 */ const $b7edcde1a56281b2$export$3cf0748e30b766d7 = $b7edcde1a56281b2$export$887ed125f549a57;


const $06c1da7f9036e9fe$var$codeChallengeMethod = 'S256';
const $06c1da7f9036e9fe$var$responseType = 'code';
const $06c1da7f9036e9fe$var$buildPrompt = (prompt)=>{
    if (Array.isArray(prompt)) return prompt.join(' ');
    return prompt ?? (0, $16df83338927e1fb$export$83716a4aa1642908).Consent;
};
// eslint-disable-next-line complexity
const $06c1da7f9036e9fe$export$b01a187f12b774c6 = ({ authorizationEndpoint: authorizationEndpoint, clientId: clientId, redirectUri: redirectUri, codeChallenge: codeChallenge, state: state, scopes: scopes, resources: resources, prompt: prompt, firstScreen: firstScreen, identifiers: identifier, interactionMode: interactionMode, loginHint: loginHint, directSignIn: directSignIn, oneTimeToken: oneTimeToken, extraParams: extraParams, includeReservedScopes: includeReservedScopes = true })=>{
    const urlSearchParameters = new URLSearchParams({
        [(0, $16df83338927e1fb$export$65f63a8bc3cba53d).ClientId]: clientId,
        [(0, $16df83338927e1fb$export$65f63a8bc3cba53d).RedirectUri]: redirectUri,
        [(0, $16df83338927e1fb$export$65f63a8bc3cba53d).CodeChallenge]: codeChallenge,
        [(0, $16df83338927e1fb$export$65f63a8bc3cba53d).CodeChallengeMethod]: $06c1da7f9036e9fe$var$codeChallengeMethod,
        [(0, $16df83338927e1fb$export$65f63a8bc3cba53d).State]: state,
        [(0, $16df83338927e1fb$export$65f63a8bc3cba53d).ResponseType]: $06c1da7f9036e9fe$var$responseType,
        [(0, $16df83338927e1fb$export$65f63a8bc3cba53d).Prompt]: $06c1da7f9036e9fe$var$buildPrompt(prompt)
    });
    const computedScopes = includeReservedScopes ? (0, $b7edcde1a56281b2$export$887ed125f549a57)(scopes) : scopes?.join(' ');
    if (computedScopes) urlSearchParameters.append((0, $16df83338927e1fb$export$65f63a8bc3cba53d).Scope, computedScopes);
    if (loginHint) urlSearchParameters.append((0, $16df83338927e1fb$export$65f63a8bc3cba53d).LoginHint, loginHint);
    if (directSignIn) urlSearchParameters.append((0, $16df83338927e1fb$export$65f63a8bc3cba53d).DirectSignIn, `${directSignIn.method}:${directSignIn.target}`);
    for (const resource of resources ?? [])urlSearchParameters.append((0, $16df83338927e1fb$export$65f63a8bc3cba53d).Resource, resource);
    if (firstScreen) urlSearchParameters.append((0, $16df83338927e1fb$export$65f63a8bc3cba53d).FirstScreen, firstScreen);
    else if (interactionMode) urlSearchParameters.append((0, $16df83338927e1fb$export$65f63a8bc3cba53d).InteractionMode, interactionMode);
    if (identifier && identifier.length > 0) urlSearchParameters.append((0, $16df83338927e1fb$export$65f63a8bc3cba53d).Identifier, identifier.join(' '));
    if (oneTimeToken) urlSearchParameters.append((0, $16df83338927e1fb$export$65f63a8bc3cba53d).OneTimeToken, oneTimeToken);
    if (extraParams) for (const [key, value] of Object.entries(extraParams))urlSearchParameters.append(key, value);
    return `${authorizationEndpoint}?${urlSearchParameters.toString()}`;
};



const $1183c93a5ee672f0$export$b3c9a2bd2330de28 = ({ endSessionEndpoint: endSessionEndpoint, clientId: clientId, postLogoutRedirectUri: postLogoutRedirectUri })=>{
    const urlSearchParameters = new URLSearchParams({
        [(0, $16df83338927e1fb$export$65f63a8bc3cba53d).ClientId]: clientId
    });
    if (postLogoutRedirectUri) urlSearchParameters.append((0, $16df83338927e1fb$export$65f63a8bc3cba53d).PostLogoutRedirectUri, postLogoutRedirectUri);
    return `${endSessionEndpoint}?${urlSearchParameters.toString()}`;
};


const $f01b1730f930c990$export$eee09f98e5b044aa = async (userInfoEndpoint, accessToken, requester)=>requester(userInfoEndpoint, {
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    });


const $e624b8b5360a6b17$export$670d48958e84d448 = (value)=>{
    if (value) return Array.isArray(value) ? value : [
        value
    ];
    return [];
};
// Disable FP rules here to use the performant approach while keep the function itself "FP"
/* eslint-disable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ const $e624b8b5360a6b17$export$76d90c956114f2c2 = (times, initial, iterate)=>{
    let result = initial;
    while(times--)result = iterate(result);
    return result;
};
/* eslint-enable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ const $e624b8b5360a6b17$export$6b75200e58bc97d0 = (array)=>[
        ...new Set(array)
    ];
/**
 * Deduplicate an array of objects by a specific key.
 *
 * @param array The array of objects to deduplicate.
 * @param key The key to deduplicate by.
 * @example
 * const array = [{ id: 1, name: 'John' }, { id: 2, name: 'Doe' }, { id: 1, name: 'John' }];
 * deduplicateByKey(array, 'id');
 * // Output: [{ id: 1, name: 'John' }, { id: 2, name: 'Doe' }]
 */ const $e624b8b5360a6b17$export$863d7151f7b1a894 = (array, key)=>[
        ...new Map(array.map((item)=>[
                item[key],
                item
            ])).values()
    ];


// https://github.com/facebook/jest/issues/7547
const $6b64eef213bf5a7e$export$a7a9523472993e97 = (value, error)=>{
    if (!value) // https://github.com/typescript-eslint/typescript-eslint/issues/3814
    // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw error;
};


// eslint-disable-next-line id-length
const $7dc19cd790b977f2$var$compareFunction = (a, b)=>{
    if (typeof a === 'string' && typeof b === 'string') return a.localeCompare(b);
    if (typeof a === 'number' && typeof b === 'number') return a - b;
    if (typeof a === 'boolean' && typeof b === 'boolean') return Number(a) - Number(b);
    throw new Error('Unsupported compare type');
};
const $7dc19cd790b977f2$export$12dc7a11e2f7584e = (array1, array2)=>{
    if (array1.length !== array2.length) return false;
    const sortedA = array1.slice().sort($7dc19cd790b977f2$var$compareFunction);
    const sortedB = array2.slice().sort($7dc19cd790b977f2$var$compareFunction);
    return sortedA.every((value, index)=>value === sortedB[index]);
};
// eslint-disable-next-line unicorn/prefer-native-coercion-functions
const $7dc19cd790b977f2$export$ccb441c9c5feb3fc = (value)=>Boolean(value);
const $7dc19cd790b977f2$export$b29ea735dcfba3c1 = (value)=>value !== null && value !== undefined;
const $7dc19cd790b977f2$export$a4f4bb6b1453fff5 = (data, property)=>Object.prototype.hasOwnProperty.call(data, property);
const $7dc19cd790b977f2$export$fb789885f1f64dd7 = (string)=>Boolean(/[\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFAFF]/.test(string));
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */ // eslint-disable-next-line @typescript-eslint/ban-types -- this is a utility function
const $7dc19cd790b977f2$var$isObject = (object)=>Object.prototype.toString.call(object) === '[object Object]';
/** Returns true if an object was created by the `Object` constructor, or `Object.create(null)`. */ function $7dc19cd790b977f2$export$53b83ca8eaab0383(object) {
    if (!$7dc19cd790b977f2$var$isObject(object)) return false;
    // If has modified constructor
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (object.constructor === undefined) return true;
    // If has modified prototype
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, prefer-destructuring
    const prototype = object.constructor.prototype;
    if (!$7dc19cd790b977f2$var$isObject(prototype)) return false;
    // If constructor does not have an Object-specific method
    if (!$7dc19cd790b977f2$export$a4f4bb6b1453fff5(prototype, 'isPrototypeOf')) return false;
    // Most likely a plain Object
    return true;
}



const $26adfd4e288f2886$export$133fc36489ac9add = (exp)=>(0, $7dc19cd790b977f2$export$ccb441c9c5feb3fc)(exp) ? exp : null;
/**
 * Conditional return the expression result when it's not {@link Falsy};
 * otherwise return `undefined`.
 *
 * @example
 * ```ts
 * conditional(1 && '2') // '2'
 * conditional(false && '1') // undefined
 * ```
 */ const $26adfd4e288f2886$export$c327da55a124987a = (exp)=>(0, $7dc19cd790b977f2$export$ccb441c9c5feb3fc)(exp) ? exp : undefined;
/** Alias for {@link conditional}. */ const $26adfd4e288f2886$export$7ffafceb12143143 = $26adfd4e288f2886$export$c327da55a124987a;
/**
 * Conditional return the stringified expression result (using `String`) when it's not {@link Falsy};
 * otherwise return an empty string.
 *
 * @example
 * ```ts
 * conditionalString(1 && 2) // '2'
 * conditionalString(false && '1') // ''
 * ```
 */ const $26adfd4e288f2886$export$78aa88a01782ee9d = (exp)=>(0, $7dc19cd790b977f2$export$ccb441c9c5feb3fc)(exp) ? String(exp) : '';
/** Alias for {@link conditionalString}. */ const $26adfd4e288f2886$export$723fe479c809eebc = $26adfd4e288f2886$export$78aa88a01782ee9d;
/**
 * Conditional concat multiple expression results into a array by filtering all {@link Falsy} results
 * and flatten 1 level deep if the expression result is an array.
 *
 * @example
 * ```ts
 * conditionalArray(1, [2, 3]) // [1, 2, 3]
 * ```
 */ const $26adfd4e288f2886$export$c96eff0e57d59a5e = (...exps)=>exps.filter((value)=>(0, $7dc19cd790b977f2$export$ccb441c9c5feb3fc)(value)).flat();
/** Alias for {@link conditionalArray}. */ const $26adfd4e288f2886$export$68c43792fed28aa6 = $26adfd4e288f2886$export$c96eff0e57d59a5e;
/**
 * Return a new object with all {@link Falsy} values removed.
 * This function only performs a shallow removal, i.e. it does not remove
 * {@link Falsy} values nested in objects.
 *
 * @example
 * ```ts
 * conditionalObject({
 *   foo: 'foo',
 *   bar: undefined,
 *   baz: false,
 * }) // { foo: 'foo' }
 * ```
 */ const $26adfd4e288f2886$export$6d93be478c042166 = (object)=>// eslint-disable-next-line no-restricted-syntax
    Object.fromEntries(Object.entries(object).filter(([, value])=>(0, $7dc19cd790b977f2$export$ccb441c9c5feb3fc)(value)));
/** Alias for {@link conditionalObject}. */ const $26adfd4e288f2886$export$48ab0026c89e64fa = $26adfd4e288f2886$export$6d93be478c042166;



var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


// Browsers don't have `process`
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
const $9b7e52df873c971d$export$4bd44a2aa29d3d6e = (key, fallback = '')=>$cfae44f0dfdf62c0$exports?.env[key] ?? fallback;
const $9b7e52df873c971d$export$912b126b3b8a9cf1 = (envKey, fallback = [])=>{
    const rawValue = $9b7e52df873c971d$export$4bd44a2aa29d3d6e(envKey);
    if (!rawValue) return fallback;
    return rawValue.split(',').map((value)=>value.trim()).filter(Boolean);
};
const $9b7e52df873c971d$export$9f11f28d727ba39d = (key)=>{
    // Browsers don't have `process`
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    const value = $cfae44f0dfdf62c0$exports?.env[key];
    (0, $6b64eef213bf5a7e$export$a7a9523472993e97)(value, new Error(`env variable ${key} not found`));
    return value;
};
const $9b7e52df873c971d$export$8ee0fc9ee280b4ee = ()=>typeof window === 'undefined';


// Intended
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $38826c6c09b4e4ad$export$8793edee2d425525 = ()=>{};
const $38826c6c09b4e4ad$export$4369c812aac99591 = (value)=>value !== null && (typeof value === 'object' || typeof value === 'function') && 'then' in value && typeof value.then === 'function';
// eslint-disable-next-line @typescript-eslint/promise-function-async
const $38826c6c09b4e4ad$export$2cb2cb98cc670b59 = (exec, onError)=>{
    const handleError = (error)=>{
        if (onError instanceof Error) throw onError;
        return onError(error);
    };
    try {
        const unwrapped = typeof exec === 'function' ? exec() : exec;
        // eslint-disable-next-line promise/prefer-await-to-then
        return $38826c6c09b4e4ad$export$4369c812aac99591(unwrapped) ? unwrapped.catch(handleError) : unwrapped;
    } catch (error) {
        return handleError(error);
    }
};
// eslint-disable-next-line @typescript-eslint/promise-function-async
const $38826c6c09b4e4ad$export$a3a27526e073307 = (exec, onError)=>{
    try {
        const unwrapped = typeof exec === 'function' ? exec() : exec;
        return $38826c6c09b4e4ad$export$4369c812aac99591(unwrapped) ? unwrapped.catch((error)=>{
            onError?.(error);
        }) : unwrapped;
    } catch (error) {
        onError?.(error);
    }
};


const $b30ff0bb66f62161$export$357523c63a2253b9 = (object, ...keys)=>{
    // eslint-disable-next-line no-restricted-syntax
    return Object.fromEntries(keys.map((key)=>[
            key,
            object[key]
        ]));
};
const $b30ff0bb66f62161$export$42fd73f889ee4d63 = (...keys)=>(state)=>$b30ff0bb66f62161$export$357523c63a2253b9(state, ...keys);


function $6f28cb45688686b6$export$1294308be85b4eca(string) {
    if (typeof string !== 'string') throw new TypeError('Expected a string');
    return string.toLowerCase().replaceAll(/(?:^|\s|-)\S/g, (value)=>value.toUpperCase()).replaceAll('-', ' ');
}
/**
 * RFC 4648 section 5: base64url (URL- and filename-safe standard)
 * @link https://datatracker.ietf.org/doc/html/rfc4648#section-5
 */ const $6f28cb45688686b6$var$replaceNonUrlSafeCharacters = (base64String)=>base64String.replaceAll('+', '-').replaceAll('/', '_').replaceAll(/=+$/g, '');
const $6f28cb45688686b6$var$restoreNonUrlSafeCharacters = (base64String)=>base64String.replaceAll('-', '+').replaceAll('_', '/');
const $6f28cb45688686b6$export$cf6f352aaefa956f = {
    isSafe: (input)=>/^[\w-]*$/.test(input),
    encode: (rawString)=>{
        const encodedString = btoa(unescape(encodeURIComponent(rawString)));
        return $6f28cb45688686b6$var$replaceNonUrlSafeCharacters(encodedString);
    },
    decode: (encodedString)=>{
        const nonUrlSafeEncodedString = $6f28cb45688686b6$var$restoreNonUrlSafeCharacters(encodedString);
        return decodeURIComponent(escape(atob(nonUrlSafeEncodedString)));
    },
    replaceNonUrlSafeCharacters: $6f28cb45688686b6$var$replaceNonUrlSafeCharacters,
    restoreNonUrlSafeCharacters: $6f28cb45688686b6$var$restoreNonUrlSafeCharacters
};
const $6f28cb45688686b6$export$7a668e70ea2210d9 = (value)=>// eslint-disable-next-line no-implicit-coercion
    !!value && [
        '1',
        'true',
        'y',
        'yes',
        'yep',
        'yeah'
    ].includes(value.toLowerCase());



const $2b71ab37b6ab75e4$export$3988ae62b71be9a3 = (object, keySerial)=>{
    if (object === null || typeof object !== 'object') throw new TypeError('Non-object received in `get()`.');
    let result = object;
    for (const key of keySerial.split('.'))// @ts-expect-error for performance
    result = result[key];
    return result;
};
const $2b71ab37b6ab75e4$export$fedb900c0ea4e699 = (...args)=>(0, $38826c6c09b4e4ad$export$a3a27526e073307)(()=>$2b71ab37b6ab75e4$export$3988ae62b71be9a3(...args));
/** Same to `get()` but with the strict type definition only to enable IntelliSense. */ const $2b71ab37b6ab75e4$export$bf7199a9ebcb84a9 = (object, keySerial)=>$2b71ab37b6ab75e4$export$3988ae62b71be9a3(object, keySerial);


/** Join multiple path segments. This function exists since there's no native implementation in browser. */ const $d48f1d2cad3531a6$export$b891921babc70093 = (...segments)=>{
    const result = [];
    for (const segment of segments.join('/').split('/')){
        if (!segment || segment === '.') continue;
        if ([
            ...segment
        ].every((char)=>char === '.')) {
            // eslint-disable-next-line @silverhand/fp/no-mutating-methods
            result.pop();
            continue;
        }
        // eslint-disable-next-line @silverhand/fp/no-mutating-methods
        result.push(segment);
    }
    return '/' + result.join('/');
};
/** Append path segments to the base URL. */ const $d48f1d2cad3531a6$export$c3cef1c0537c0eb2 = (baseUrl, ...pathnames)=>new URL($d48f1d2cad3531a6$export$b891921babc70093(baseUrl.pathname, ...pathnames), baseUrl);


// eslint-disable-next-line @typescript-eslint/ban-types
const $29eb187853a6e562$export$a6cdc56e425d0d0a = (object)=>object !== null && typeof object === 'object';
const $29eb187853a6e562$export$dd89c3a817f05bc7 = (object, key)=>$29eb187853a6e562$export$a6cdc56e425d0d0a(object) && key in object;
/**
 * Remove all keys with `undefined` values from an object. This function only
 * performs a shallow removal, i.e. it does not remove `undefined` values nested
 * in objects.
 *
 * @param object The object to remove `undefined` keys from.
 * @returns A new object with all `undefined` keys removed.
 */ // eslint-disable-next-line @typescript-eslint/ban-types -- this is a utility function
const $29eb187853a6e562$export$8e7457d724841712 = (object)=>// eslint-disable-next-line no-restricted-syntax
    Object.fromEntries(Object.entries(object).filter(([, value])=>value !== undefined));


/* eslint-disable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ function $5c5654585fe663f5$export$d2de3aaeafa91619(function_) {
    let called = false;
    let result;
    return function(...args) {
        if (!called) {
            called = true;
            result = function_.apply(this, args);
        }
        return result;
    };
}





const $5071cd8c093ffe66$export$aa016a295c6092c8 = (data)=>typeof data === 'object' && data !== null;


const $0ec0fc6822140f6b$var$logtoErrorCodes = Object.freeze({
    'id_token.invalid_iat': 'Invalid issued at time in the ID token',
    'id_token.invalid_token': 'Invalid ID token',
    'callback_uri_verification.redirect_uri_mismatched': 'The callback URI mismatches the redirect URI.',
    'callback_uri_verification.error_found': 'Error found in the callback URI',
    'callback_uri_verification.missing_state': 'Missing state in the callback URI',
    'callback_uri_verification.state_mismatched': 'State mismatched in the callback URI',
    'callback_uri_verification.missing_code': 'Missing code in the callback URI',
    crypto_subtle_unavailable: 'Crypto.subtle is unavailable in insecure contexts (non-HTTPS).',
    unexpected_response_error: 'Unexpected response error from the server.'
});
class $0ec0fc6822140f6b$export$ba60d77e6748b659 extends Error {
    constructor(code, data){
        super($0ec0fc6822140f6b$var$logtoErrorCodes[code]);
        this.code = code;
        this.data = data;
        this.name = 'LogtoError';
    }
}
const $0ec0fc6822140f6b$export$27f79c8238476d38 = (data)=>{
    if (!(0, $5071cd8c093ffe66$export$aa016a295c6092c8)(data)) return false;
    return data instanceof Error && data.name === 'LogtoRequestError';
};
const $0ec0fc6822140f6b$export$4bc3e79991b9e2d4 = (data)=>{
    if (!(0, $5071cd8c093ffe66$export$aa016a295c6092c8)(data)) return false;
    return typeof data.code === 'string' && typeof data.message === 'string';
};
class $0ec0fc6822140f6b$export$e6e15b8ba42b9b70 extends Error {
    constructor(code, message, /** The original response object from the server. */ cause){
        super(message);
        this.code = code;
        this.cause = cause;
        this.name = 'LogtoRequestError';
    }
}
class $0ec0fc6822140f6b$export$d4832bcf9ce430e0 {
    constructor(error, errorDescription){
        this.error = error;
        this.errorDescription = errorDescription;
        this.name = 'OidcError';
    }
}


const $91623c234e2f4014$export$4851e69315d5b72c = (uri)=>{
    const [, queryString = ''] = uri.split('?');
    return new URLSearchParams(queryString);
};
const $91623c234e2f4014$export$dc3fae3c99763885 = (callbackUri, redirectUri, state)=>{
    if (!callbackUri.startsWith(redirectUri)) throw new (0, $0ec0fc6822140f6b$export$ba60d77e6748b659)('callback_uri_verification.redirect_uri_mismatched');
    const uriParameters = $91623c234e2f4014$export$4851e69315d5b72c(callbackUri);
    const error = (0, $26adfd4e288f2886$export$c327da55a124987a)(uriParameters.get((0, $16df83338927e1fb$export$65f63a8bc3cba53d).Error));
    const errorDescription = (0, $26adfd4e288f2886$export$c327da55a124987a)(uriParameters.get((0, $16df83338927e1fb$export$65f63a8bc3cba53d).ErrorDescription));
    if (error) throw new (0, $0ec0fc6822140f6b$export$ba60d77e6748b659)('callback_uri_verification.error_found', new (0, $0ec0fc6822140f6b$export$d4832bcf9ce430e0)(error, errorDescription));
    const stateFromCallbackUri = uriParameters.get((0, $16df83338927e1fb$export$65f63a8bc3cba53d).State);
    if (!stateFromCallbackUri) throw new (0, $0ec0fc6822140f6b$export$ba60d77e6748b659)('callback_uri_verification.missing_state');
    if (stateFromCallbackUri !== state) throw new (0, $0ec0fc6822140f6b$export$ba60d77e6748b659)('callback_uri_verification.state_mismatched');
    const code = uriParameters.get((0, $16df83338927e1fb$export$65f63a8bc3cba53d).Code);
    if (!code) throw new (0, $0ec0fc6822140f6b$export$ba60d77e6748b659)('callback_uri_verification.missing_code');
    return code;
};






/* eslint-disable complexity */ /**
 * @link [ID Token](https://openid.net/specs/openid-connect-core-1_0.html#IDToken)
 */ function $30fe7a95172a63a5$var$assertIdTokenClaims(data) {
    if (!(0, $5071cd8c093ffe66$export$aa016a295c6092c8)(data)) throw new TypeError('IdToken is expected to be an object');
    for (const key of [
        'iss',
        'sub',
        'aud'
    ]){
        if (typeof data[key] !== 'string') throw new TypeError(`At path: IdToken.${key}: expected a string`);
    }
    for (const key of [
        'exp',
        'iat'
    ]){
        if (typeof data[key] !== 'number') throw new TypeError(`At path: IdToken.${key}: expected a number`);
    }
    for (const key of [
        'at_hash',
        'name',
        'username',
        'picture',
        'email',
        'phone_number'
    ]){
        if (data[key] === undefined) continue;
        if (typeof data[key] !== 'string' && data[key] !== null) throw new TypeError(`At path: IdToken.${key}: expected null or a string`);
    }
    for (const key of [
        'email_verified',
        'phone_number_verified'
    ]){
        if (data[key] === undefined) continue;
        if (typeof data[key] !== 'boolean') throw new TypeError(`At path: IdToken.${key}: expected a boolean`);
    }
}
/* eslint-enable complexity */ const $30fe7a95172a63a5$export$aac2d5b7f5cd16d5 = (token)=>{
    const { 1: encodedPayload } = token.split('.');
    if (!encodedPayload) throw new (0, $0ec0fc6822140f6b$export$ba60d77e6748b659)('id_token.invalid_token');
    const json = (0, $6f28cb45688686b6$export$cf6f352aaefa956f).decode(encodedPayload);
    const idTokenClaims = JSON.parse(json);
    $30fe7a95172a63a5$var$assertIdTokenClaims(idTokenClaims);
    return idTokenClaims;
};




// https://docs.logto.io/docs/recipes/protect-your-api/
function $cd44eece04b021e0$var$assertAccessTokenClaims(data) {
    if (!(0, $5071cd8c093ffe66$export$aa016a295c6092c8)(data)) throw new TypeError('AccessToken is expected to be an object');
    for (const key of [
        'jti',
        'iss',
        'sub',
        'aud',
        'client_id',
        'scope'
    ]){
        if (data[key] === undefined) continue;
        if (typeof data[key] !== 'string' && data[key] !== null) throw new TypeError(`At path: AccessToken.${key}: expected null or a string`);
    }
    for (const key of [
        'exp',
        'iat'
    ]){
        if (data[key] === undefined) continue;
        if (typeof data[key] !== 'number' && data[key] !== null) throw new TypeError(`At path: AccessToken.${key}: expected null or a number`);
    }
}
const $cd44eece04b021e0$export$1b57a6e65b75f5b3 = (accessToken)=>{
    const { 1: encodedPayload } = accessToken.split('.');
    if (!encodedPayload) // Non-JWT format token string
    return {};
    const json = (0, $6f28cb45688686b6$export$cf6f352aaefa956f).decode(encodedPayload);
    const accessTokenClaims = JSON.parse(json);
    $cd44eece04b021e0$var$assertAccessTokenClaims(accessTokenClaims);
    return accessTokenClaims;
};








class $599ac781534a947a$export$f754d6850d76bf87 extends Error {
    constructor(message, options){
        super(message, options);
        this.code = 'ERR_JOSE_GENERIC';
        this.name = this.constructor.name;
        Error.captureStackTrace?.(this, this.constructor);
    }
}
$599ac781534a947a$export$f754d6850d76bf87.code = 'ERR_JOSE_GENERIC';
class $599ac781534a947a$export$f1e14efb908196e9 extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(message, payload, claim = 'unspecified', reason = 'unspecified'){
        super(message, {
            cause: {
                claim: claim,
                reason: reason,
                payload: payload
            }
        });
        this.code = 'ERR_JWT_CLAIM_VALIDATION_FAILED';
        this.claim = claim;
        this.reason = reason;
        this.payload = payload;
    }
}
$599ac781534a947a$export$f1e14efb908196e9.code = 'ERR_JWT_CLAIM_VALIDATION_FAILED';
class $599ac781534a947a$export$4b386bf852b7863d extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(message, payload, claim = 'unspecified', reason = 'unspecified'){
        super(message, {
            cause: {
                claim: claim,
                reason: reason,
                payload: payload
            }
        });
        this.code = 'ERR_JWT_EXPIRED';
        this.claim = claim;
        this.reason = reason;
        this.payload = payload;
    }
}
$599ac781534a947a$export$4b386bf852b7863d.code = 'ERR_JWT_EXPIRED';
class $599ac781534a947a$export$d51fd7fedeccc338 extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = 'ERR_JOSE_ALG_NOT_ALLOWED';
    }
}
$599ac781534a947a$export$d51fd7fedeccc338.code = 'ERR_JOSE_ALG_NOT_ALLOWED';
class $599ac781534a947a$export$19ddbcbf2016ab28 extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = 'ERR_JOSE_NOT_SUPPORTED';
    }
}
$599ac781534a947a$export$19ddbcbf2016ab28.code = 'ERR_JOSE_NOT_SUPPORTED';
class $599ac781534a947a$export$1a57512ad9773b2a extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(message = 'decryption operation failed', options){
        super(message, options);
        this.code = 'ERR_JWE_DECRYPTION_FAILED';
    }
}
$599ac781534a947a$export$1a57512ad9773b2a.code = 'ERR_JWE_DECRYPTION_FAILED';
class $599ac781534a947a$export$19f281f2275f6a15 extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = 'ERR_JWE_INVALID';
    }
}
$599ac781534a947a$export$19f281f2275f6a15.code = 'ERR_JWE_INVALID';
class $599ac781534a947a$export$e838de724af3d116 extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = 'ERR_JWS_INVALID';
    }
}
$599ac781534a947a$export$e838de724af3d116.code = 'ERR_JWS_INVALID';
class $599ac781534a947a$export$936b39ada0bbfceb extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = 'ERR_JWT_INVALID';
    }
}
$599ac781534a947a$export$936b39ada0bbfceb.code = 'ERR_JWT_INVALID';
class $599ac781534a947a$export$b3992e0f88fb07e3 extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = 'ERR_JWK_INVALID';
    }
}
$599ac781534a947a$export$b3992e0f88fb07e3.code = 'ERR_JWK_INVALID';
class $599ac781534a947a$export$9b22c2a1e2403b8e extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = 'ERR_JWKS_INVALID';
    }
}
$599ac781534a947a$export$9b22c2a1e2403b8e.code = 'ERR_JWKS_INVALID';
class $599ac781534a947a$export$3d5ed1a538bed04e extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(message = 'no applicable key found in the JSON Web Key Set', options){
        super(message, options);
        this.code = 'ERR_JWKS_NO_MATCHING_KEY';
    }
}
$599ac781534a947a$export$3d5ed1a538bed04e.code = 'ERR_JWKS_NO_MATCHING_KEY';
class $599ac781534a947a$export$dc036de401a5c284 extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(message = 'multiple matching keys found in the JSON Web Key Set', options){
        super(message, options);
        this.code = 'ERR_JWKS_MULTIPLE_MATCHING_KEYS';
    }
}
Symbol.asyncIterator;
$599ac781534a947a$export$dc036de401a5c284.code = 'ERR_JWKS_MULTIPLE_MATCHING_KEYS';
class $599ac781534a947a$export$3f30acebf25c04e6 extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(message = 'request timed out', options){
        super(message, options);
        this.code = 'ERR_JWKS_TIMEOUT';
    }
}
$599ac781534a947a$export$3f30acebf25c04e6.code = 'ERR_JWKS_TIMEOUT';
class $599ac781534a947a$export$c67a0218e7c50378 extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(message = 'signature verification failed', options){
        super(message, options);
        this.code = 'ERR_JWS_SIGNATURE_VERIFICATION_FAILED';
    }
}
$599ac781534a947a$export$c67a0218e7c50378.code = 'ERR_JWS_SIGNATURE_VERIFICATION_FAILED';


const $22e7f56c38b2bd5a$var$fetchJwks = async (url, timeout, options)=>{
    let controller;
    let id;
    let timedOut = false;
    if (typeof AbortController === 'function') {
        controller = new AbortController();
        id = setTimeout(()=>{
            timedOut = true;
            controller.abort();
        }, timeout);
    }
    const response = await fetch(url.href, {
        signal: controller ? controller.signal : undefined,
        redirect: 'manual',
        headers: options.headers
    }).catch((err)=>{
        if (timedOut) throw new (0, $599ac781534a947a$export$3f30acebf25c04e6)();
        throw err;
    });
    if (id !== undefined) clearTimeout(id);
    if (response.status !== 200) throw new (0, $599ac781534a947a$export$f754d6850d76bf87)('Expected 200 OK from the JSON Web Key Set HTTP response');
    try {
        return await response.json();
    } catch  {
        throw new (0, $599ac781534a947a$export$f754d6850d76bf87)('Failed to parse the JSON Web Key Set HTTP response as JSON');
    }
};
var $22e7f56c38b2bd5a$export$2e2bcd8739ae039 = $22e7f56c38b2bd5a$var$fetchJwks;



var $3f0b33e7ccc65ae0$export$2e2bcd8739ae039 = crypto;
const $3f0b33e7ccc65ae0$export$600b5603bbac4c6 = (key)=>key instanceof CryptoKey;


const $491757e359519ceb$var$digest = async (algorithm, data)=>{
    const subtleDigest = `SHA-${algorithm.slice(-3)}`;
    return new Uint8Array(await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.digest(subtleDigest, data));
};
var $491757e359519ceb$export$2e2bcd8739ae039 = $491757e359519ceb$var$digest;


const $8c3dacf85b96b392$export$5486af06137bf21a = new TextEncoder();
const $8c3dacf85b96b392$export$124c96e6ce37090b = new TextDecoder();
const $8c3dacf85b96b392$var$MAX_INT32 = 2 ** 32;
function $8c3dacf85b96b392$export$ee1b3e54f0441b22(...buffers) {
    const size = buffers.reduce((acc, { length: length })=>acc + length, 0);
    const buf = new Uint8Array(size);
    let i = 0;
    for (const buffer of buffers){
        buf.set(buffer, i);
        i += buffer.length;
    }
    return buf;
}
function $8c3dacf85b96b392$export$256d3ca12372f112(alg, p2sInput) {
    return $8c3dacf85b96b392$export$ee1b3e54f0441b22($8c3dacf85b96b392$export$5486af06137bf21a.encode(alg), new Uint8Array([
        0
    ]), p2sInput);
}
function $8c3dacf85b96b392$var$writeUInt32BE(buf, value, offset) {
    if (value < 0 || value >= $8c3dacf85b96b392$var$MAX_INT32) throw new RangeError(`value must be >= 0 and <= ${$8c3dacf85b96b392$var$MAX_INT32 - 1}. Received ${value}`);
    buf.set([
        value >>> 24,
        value >>> 16,
        value >>> 8,
        value & 0xff
    ], offset);
}
function $8c3dacf85b96b392$export$e7b531e00a18fdd7(value) {
    const high = Math.floor(value / $8c3dacf85b96b392$var$MAX_INT32);
    const low = value % $8c3dacf85b96b392$var$MAX_INT32;
    const buf = new Uint8Array(8);
    $8c3dacf85b96b392$var$writeUInt32BE(buf, high, 0);
    $8c3dacf85b96b392$var$writeUInt32BE(buf, low, 4);
    return buf;
}
function $8c3dacf85b96b392$export$74c16dba6c885532(value) {
    const buf = new Uint8Array(4);
    $8c3dacf85b96b392$var$writeUInt32BE(buf, value);
    return buf;
}
function $8c3dacf85b96b392$export$c1498c4a3718d967(input) {
    return $8c3dacf85b96b392$export$ee1b3e54f0441b22($8c3dacf85b96b392$export$74c16dba6c885532(input.length), input);
}
async function $8c3dacf85b96b392$export$67163693c21af44f(secret, bits, value) {
    const iterations = Math.ceil((bits >> 3) / 32);
    const res = new Uint8Array(iterations * 32);
    for(let iter = 0; iter < iterations; iter++){
        const buf = new Uint8Array(4 + secret.length + value.length);
        buf.set($8c3dacf85b96b392$export$74c16dba6c885532(iter + 1));
        buf.set(secret, 4);
        buf.set(value, 4 + secret.length);
        res.set(await (0, $491757e359519ceb$export$2e2bcd8739ae039)('sha256', buf), iter * 32);
    }
    return res.slice(0, bits >> 3);
}


const $54a6e0e463467b0a$export$8fb536984ec8b4d7 = (input)=>{
    let unencoded = input;
    if (typeof unencoded === 'string') unencoded = (0, $8c3dacf85b96b392$export$5486af06137bf21a).encode(unencoded);
    const CHUNK_SIZE = 0x8000;
    const arr = [];
    for(let i = 0; i < unencoded.length; i += CHUNK_SIZE)arr.push(String.fromCharCode.apply(null, unencoded.subarray(i, i + CHUNK_SIZE)));
    return btoa(arr.join(''));
};
const $54a6e0e463467b0a$export$c564cdbbe6da493 = (input)=>{
    return $54a6e0e463467b0a$export$8fb536984ec8b4d7(input).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
};
const $54a6e0e463467b0a$export$94fdf11bafc8de6b = (encoded)=>{
    const binary = atob(encoded);
    const bytes = new Uint8Array(binary.length);
    for(let i = 0; i < binary.length; i++)bytes[i] = binary.charCodeAt(i);
    return bytes;
};
const $54a6e0e463467b0a$export$2f872c0f2117be69 = (input)=>{
    let encoded = input;
    if (encoded instanceof Uint8Array) encoded = (0, $8c3dacf85b96b392$export$124c96e6ce37090b).decode(encoded);
    encoded = encoded.replace(/-/g, '+').replace(/_/g, '/').replace(/\s/g, '');
    try {
        return $54a6e0e463467b0a$export$94fdf11bafc8de6b(encoded);
    } catch  {
        throw new TypeError('The input to be decoded is not correctly encoded.');
    }
};



function $233e587bc0c17441$var$message(msg, actual, ...types) {
    types = types.filter(Boolean);
    if (types.length > 2) {
        const last = types.pop();
        msg += `one of type ${types.join(', ')}, or ${last}.`;
    } else if (types.length === 2) msg += `one of type ${types[0]} or ${types[1]}.`;
    else msg += `of type ${types[0]}.`;
    if (actual == null) msg += ` Received ${actual}`;
    else if (typeof actual === 'function' && actual.name) msg += ` Received function ${actual.name}`;
    else if (typeof actual === 'object' && actual != null) {
        if (actual.constructor?.name) msg += ` Received an instance of ${actual.constructor.name}`;
    }
    return msg;
}
var $233e587bc0c17441$export$2e2bcd8739ae039 = (actual, ...types)=>{
    return $233e587bc0c17441$var$message('Key must be ', actual, ...types);
};
function $233e587bc0c17441$export$e94f758d09bc1828(alg, actual, ...types) {
    return $233e587bc0c17441$var$message(`Key for the ${alg} algorithm must be `, actual, ...types);
}



var $9ffaef5451229e15$export$2e2bcd8739ae039 = (b64, descriptor)=>{
    const newlined = (b64.match(/.{1,64}/g) || []).join('\n');
    return `-----BEGIN ${descriptor}-----\n${newlined}\n-----END ${descriptor}-----`;
};




var $002bdc4a0215a55c$export$2e2bcd8739ae039 = (key)=>{
    if ((0, $3f0b33e7ccc65ae0$export$600b5603bbac4c6)(key)) return true;
    return key?.[Symbol.toStringTag] === 'KeyObject';
};
const $002bdc4a0215a55c$export$b14ad400b1d09e0f = [
    'CryptoKey'
];


const $b876728f20516af6$var$genericExport = async (keyType, keyFormat, key)=>{
    if (!(0, $3f0b33e7ccc65ae0$export$600b5603bbac4c6)(key)) throw new TypeError((0, $233e587bc0c17441$export$2e2bcd8739ae039)(key, ...(0, $002bdc4a0215a55c$export$b14ad400b1d09e0f)));
    if (!key.extractable) throw new TypeError('CryptoKey is not extractable');
    if (key.type !== keyType) throw new TypeError(`key is not a ${keyType} key`);
    return (0, $9ffaef5451229e15$export$2e2bcd8739ae039)((0, $54a6e0e463467b0a$export$8fb536984ec8b4d7)(new Uint8Array(await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.exportKey(keyFormat, key))), `${keyType.toUpperCase()} KEY`);
};
const $b876728f20516af6$export$cfba7e924fe414ca = (key)=>{
    return $b876728f20516af6$var$genericExport('public', 'spki', key);
};
const $b876728f20516af6$export$cac76a78a90b914d = (key)=>{
    return $b876728f20516af6$var$genericExport('private', 'pkcs8', key);
};
const $b876728f20516af6$var$findOid = (keyData, oid, from = 0)=>{
    if (from === 0) {
        oid.unshift(oid.length);
        oid.unshift(0x06);
    }
    const i = keyData.indexOf(oid[0], from);
    if (i === -1) return false;
    const sub = keyData.subarray(i, i + oid.length);
    if (sub.length !== oid.length) return false;
    return sub.every((value, index)=>value === oid[index]) || $b876728f20516af6$var$findOid(keyData, oid, i + 1);
};
const $b876728f20516af6$var$getNamedCurve = (keyData)=>{
    switch(true){
        case $b876728f20516af6$var$findOid(keyData, [
            0x2a,
            0x86,
            0x48,
            0xce,
            0x3d,
            0x03,
            0x01,
            0x07
        ]):
            return 'P-256';
        case $b876728f20516af6$var$findOid(keyData, [
            0x2b,
            0x81,
            0x04,
            0x00,
            0x22
        ]):
            return 'P-384';
        case $b876728f20516af6$var$findOid(keyData, [
            0x2b,
            0x81,
            0x04,
            0x00,
            0x23
        ]):
            return 'P-521';
        case $b876728f20516af6$var$findOid(keyData, [
            0x2b,
            0x65,
            0x6e
        ]):
            return 'X25519';
        case $b876728f20516af6$var$findOid(keyData, [
            0x2b,
            0x65,
            0x6f
        ]):
            return 'X448';
        case $b876728f20516af6$var$findOid(keyData, [
            0x2b,
            0x65,
            0x70
        ]):
            return 'Ed25519';
        case $b876728f20516af6$var$findOid(keyData, [
            0x2b,
            0x65,
            0x71
        ]):
            return 'Ed448';
        default:
            throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)('Invalid or unsupported EC Key Curve or OKP Key Sub Type');
    }
};
const $b876728f20516af6$var$genericImport = async (replace, keyFormat, pem, alg, options)=>{
    let algorithm;
    let keyUsages;
    const keyData = new Uint8Array(atob(pem.replace(replace, '')).split('').map((c)=>c.charCodeAt(0)));
    const isPublic = keyFormat === 'spki';
    switch(alg){
        case 'PS256':
        case 'PS384':
        case 'PS512':
            algorithm = {
                name: 'RSA-PSS',
                hash: `SHA-${alg.slice(-3)}`
            };
            keyUsages = isPublic ? [
                'verify'
            ] : [
                'sign'
            ];
            break;
        case 'RS256':
        case 'RS384':
        case 'RS512':
            algorithm = {
                name: 'RSASSA-PKCS1-v1_5',
                hash: `SHA-${alg.slice(-3)}`
            };
            keyUsages = isPublic ? [
                'verify'
            ] : [
                'sign'
            ];
            break;
        case 'RSA-OAEP':
        case 'RSA-OAEP-256':
        case 'RSA-OAEP-384':
        case 'RSA-OAEP-512':
            algorithm = {
                name: 'RSA-OAEP',
                hash: `SHA-${parseInt(alg.slice(-3), 10) || 1}`
            };
            keyUsages = isPublic ? [
                'encrypt',
                'wrapKey'
            ] : [
                'decrypt',
                'unwrapKey'
            ];
            break;
        case 'ES256':
            algorithm = {
                name: 'ECDSA',
                namedCurve: 'P-256'
            };
            keyUsages = isPublic ? [
                'verify'
            ] : [
                'sign'
            ];
            break;
        case 'ES384':
            algorithm = {
                name: 'ECDSA',
                namedCurve: 'P-384'
            };
            keyUsages = isPublic ? [
                'verify'
            ] : [
                'sign'
            ];
            break;
        case 'ES512':
            algorithm = {
                name: 'ECDSA',
                namedCurve: 'P-521'
            };
            keyUsages = isPublic ? [
                'verify'
            ] : [
                'sign'
            ];
            break;
        case 'ECDH-ES':
        case 'ECDH-ES+A128KW':
        case 'ECDH-ES+A192KW':
        case 'ECDH-ES+A256KW':
            {
                const namedCurve = $b876728f20516af6$var$getNamedCurve(keyData);
                algorithm = namedCurve.startsWith('P-') ? {
                    name: 'ECDH',
                    namedCurve: namedCurve
                } : {
                    name: namedCurve
                };
                keyUsages = isPublic ? [] : [
                    'deriveBits'
                ];
                break;
            }
        case 'Ed25519':
            algorithm = {
                name: 'Ed25519'
            };
            keyUsages = isPublic ? [
                'verify'
            ] : [
                'sign'
            ];
            break;
        case 'EdDSA':
            algorithm = {
                name: $b876728f20516af6$var$getNamedCurve(keyData)
            };
            keyUsages = isPublic ? [
                'verify'
            ] : [
                'sign'
            ];
            break;
        default:
            throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)('Invalid or unsupported "alg" (Algorithm) value');
    }
    return (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.importKey(keyFormat, keyData, algorithm, options?.extractable ?? false, keyUsages);
};
const $b876728f20516af6$export$224b0a6339c7267f = (pem, alg, options)=>{
    return $b876728f20516af6$var$genericImport(/(?:-----(?:BEGIN|END) PRIVATE KEY-----|\s)/g, 'pkcs8', pem, alg, options);
};
const $b876728f20516af6$export$f9a3505cdaa1fb3e = (pem, alg, options)=>{
    return $b876728f20516af6$var$genericImport(/(?:-----(?:BEGIN|END) PUBLIC KEY-----|\s)/g, 'spki', pem, alg, options);
};
function $b876728f20516af6$var$getElement(seq) {
    const result = [];
    let next = 0;
    while(next < seq.length){
        const nextPart = $b876728f20516af6$var$parseElement(seq.subarray(next));
        result.push(nextPart);
        next += nextPart.byteLength;
    }
    return result;
}
function $b876728f20516af6$var$parseElement(bytes) {
    let position = 0;
    let tag = bytes[0] & 0x1f;
    position++;
    if (tag === 0x1f) {
        tag = 0;
        while(bytes[position] >= 0x80){
            tag = tag * 128 + bytes[position] - 0x80;
            position++;
        }
        tag = tag * 128 + bytes[position] - 0x80;
        position++;
    }
    let length = 0;
    if (bytes[position] < 0x80) {
        length = bytes[position];
        position++;
    } else if (length === 0x80) {
        length = 0;
        while(bytes[position + length] !== 0 || bytes[position + length + 1] !== 0){
            if (length > bytes.byteLength) throw new TypeError('invalid indefinite form length');
            length++;
        }
        const byteLength = position + length + 2;
        return {
            byteLength: byteLength,
            contents: bytes.subarray(position, position + length),
            raw: bytes.subarray(0, byteLength)
        };
    } else {
        const numberOfDigits = bytes[position] & 0x7f;
        position++;
        length = 0;
        for(let i = 0; i < numberOfDigits; i++){
            length = length * 256 + bytes[position];
            position++;
        }
    }
    const byteLength = position + length;
    return {
        byteLength: byteLength,
        contents: bytes.subarray(position, byteLength),
        raw: bytes.subarray(0, byteLength)
    };
}
function $b876728f20516af6$var$spkiFromX509(buf) {
    const tbsCertificate = $b876728f20516af6$var$getElement($b876728f20516af6$var$getElement($b876728f20516af6$var$parseElement(buf).contents)[0].contents);
    return (0, $54a6e0e463467b0a$export$8fb536984ec8b4d7)(tbsCertificate[tbsCertificate[0].raw[0] === 0xa0 ? 6 : 5].raw);
}
function $b876728f20516af6$var$getSPKI(x509) {
    const pem = x509.replace(/(?:-----(?:BEGIN|END) CERTIFICATE-----|\s)/g, '');
    const raw = (0, $54a6e0e463467b0a$export$94fdf11bafc8de6b)(pem);
    return (0, $9ffaef5451229e15$export$2e2bcd8739ae039)($b876728f20516af6$var$spkiFromX509(raw), 'PUBLIC KEY');
}
const $b876728f20516af6$export$ed788b6a8533858f = (pem, alg, options)=>{
    let spki;
    try {
        spki = $b876728f20516af6$var$getSPKI(pem);
    } catch (cause) {
        throw new TypeError('Failed to parse the X.509 certificate', {
            cause: cause
        });
    }
    return $b876728f20516af6$export$f9a3505cdaa1fb3e(spki, alg, options);
};




function $337343867c42a494$var$subtleMapping(jwk) {
    let algorithm;
    let keyUsages;
    switch(jwk.kty){
        case 'RSA':
            switch(jwk.alg){
                case 'PS256':
                case 'PS384':
                case 'PS512':
                    algorithm = {
                        name: 'RSA-PSS',
                        hash: `SHA-${jwk.alg.slice(-3)}`
                    };
                    keyUsages = jwk.d ? [
                        'sign'
                    ] : [
                        'verify'
                    ];
                    break;
                case 'RS256':
                case 'RS384':
                case 'RS512':
                    algorithm = {
                        name: 'RSASSA-PKCS1-v1_5',
                        hash: `SHA-${jwk.alg.slice(-3)}`
                    };
                    keyUsages = jwk.d ? [
                        'sign'
                    ] : [
                        'verify'
                    ];
                    break;
                case 'RSA-OAEP':
                case 'RSA-OAEP-256':
                case 'RSA-OAEP-384':
                case 'RSA-OAEP-512':
                    algorithm = {
                        name: 'RSA-OAEP',
                        hash: `SHA-${parseInt(jwk.alg.slice(-3), 10) || 1}`
                    };
                    keyUsages = jwk.d ? [
                        'decrypt',
                        'unwrapKey'
                    ] : [
                        'encrypt',
                        'wrapKey'
                    ];
                    break;
                default:
                    throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        case 'EC':
            switch(jwk.alg){
                case 'ES256':
                    algorithm = {
                        name: 'ECDSA',
                        namedCurve: 'P-256'
                    };
                    keyUsages = jwk.d ? [
                        'sign'
                    ] : [
                        'verify'
                    ];
                    break;
                case 'ES384':
                    algorithm = {
                        name: 'ECDSA',
                        namedCurve: 'P-384'
                    };
                    keyUsages = jwk.d ? [
                        'sign'
                    ] : [
                        'verify'
                    ];
                    break;
                case 'ES512':
                    algorithm = {
                        name: 'ECDSA',
                        namedCurve: 'P-521'
                    };
                    keyUsages = jwk.d ? [
                        'sign'
                    ] : [
                        'verify'
                    ];
                    break;
                case 'ECDH-ES':
                case 'ECDH-ES+A128KW':
                case 'ECDH-ES+A192KW':
                case 'ECDH-ES+A256KW':
                    algorithm = {
                        name: 'ECDH',
                        namedCurve: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        'deriveBits'
                    ] : [];
                    break;
                default:
                    throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        case 'OKP':
            switch(jwk.alg){
                case 'Ed25519':
                    algorithm = {
                        name: 'Ed25519'
                    };
                    keyUsages = jwk.d ? [
                        'sign'
                    ] : [
                        'verify'
                    ];
                    break;
                case 'EdDSA':
                    algorithm = {
                        name: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        'sign'
                    ] : [
                        'verify'
                    ];
                    break;
                case 'ECDH-ES':
                case 'ECDH-ES+A128KW':
                case 'ECDH-ES+A192KW':
                case 'ECDH-ES+A256KW':
                    algorithm = {
                        name: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        'deriveBits'
                    ] : [];
                    break;
                default:
                    throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        default:
            throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "kty" (Key Type) Parameter value');
    }
    return {
        algorithm: algorithm,
        keyUsages: keyUsages
    };
}
const $337343867c42a494$var$parse = async (jwk)=>{
    if (!jwk.alg) throw new TypeError('"alg" argument is required when "jwk.alg" is not present');
    const { algorithm: algorithm, keyUsages: keyUsages } = $337343867c42a494$var$subtleMapping(jwk);
    const rest = [
        algorithm,
        jwk.ext ?? false,
        jwk.key_ops ?? keyUsages
    ];
    const keyData = {
        ...jwk
    };
    delete keyData.alg;
    delete keyData.use;
    return (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.importKey('jwk', keyData, ...rest);
};
var $337343867c42a494$export$2e2bcd8739ae039 = $337343867c42a494$var$parse;



function $319a04fbce04ffdb$var$isObjectLike(value) {
    return typeof value === 'object' && value !== null;
}
function $319a04fbce04ffdb$export$2e2bcd8739ae039(input) {
    if (!$319a04fbce04ffdb$var$isObjectLike(input) || Object.prototype.toString.call(input) !== '[object Object]') return false;
    if (Object.getPrototypeOf(input) === null) return true;
    let proto = input;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(input) === proto;
}


async function $d3f3b992c534ed5a$export$7cdfc961c11d0266(spki, alg, options) {
    if (typeof spki !== 'string' || spki.indexOf('-----BEGIN PUBLIC KEY-----') !== 0) throw new TypeError('"spki" must be SPKI formatted string');
    return (0, $b876728f20516af6$export$f9a3505cdaa1fb3e)(spki, alg, options);
}
async function $d3f3b992c534ed5a$export$948757ecbbf4a918(x509, alg, options) {
    if (typeof x509 !== 'string' || x509.indexOf('-----BEGIN CERTIFICATE-----') !== 0) throw new TypeError('"x509" must be X.509 formatted string');
    return (0, $b876728f20516af6$export$ed788b6a8533858f)(x509, alg, options);
}
async function $d3f3b992c534ed5a$export$17f5e7f6d2848df5(pkcs8, alg, options) {
    if (typeof pkcs8 !== 'string' || pkcs8.indexOf('-----BEGIN PRIVATE KEY-----') !== 0) throw new TypeError('"pkcs8" must be PKCS#8 formatted string');
    return (0, $b876728f20516af6$export$224b0a6339c7267f)(pkcs8, alg, options);
}
async function $d3f3b992c534ed5a$export$2b70d37b4d0b888b(jwk, alg) {
    if (!(0, $319a04fbce04ffdb$export$2e2bcd8739ae039)(jwk)) throw new TypeError('JWK must be an object');
    alg || (alg = jwk.alg);
    switch(jwk.kty){
        case 'oct':
            if (typeof jwk.k !== 'string' || !jwk.k) throw new TypeError('missing "k" (Key Value) Parameter value');
            return (0, $54a6e0e463467b0a$export$2f872c0f2117be69)(jwk.k);
        case 'RSA':
            if ('oth' in jwk && jwk.oth !== undefined) throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)('RSA JWK "oth" (Other Primes Info) Parameter value is not supported');
        case 'EC':
        case 'OKP':
            return (0, $337343867c42a494$export$2e2bcd8739ae039)({
                ...jwk,
                alg: alg
            });
        default:
            throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)('Unsupported "kty" (Key Type) Parameter value');
    }
}




function $34d7790339015997$var$getKtyFromAlg(alg) {
    switch(typeof alg === 'string' && alg.slice(0, 2)){
        case 'RS':
        case 'PS':
            return 'RSA';
        case 'ES':
            return 'EC';
        case 'Ed':
            return 'OKP';
        default:
            throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)('Unsupported "alg" value for a JSON Web Key Set');
    }
}
function $34d7790339015997$var$isJWKSLike(jwks) {
    return jwks && typeof jwks === 'object' && Array.isArray(jwks.keys) && jwks.keys.every($34d7790339015997$var$isJWKLike);
}
function $34d7790339015997$var$isJWKLike(key) {
    return (0, $319a04fbce04ffdb$export$2e2bcd8739ae039)(key);
}
function $34d7790339015997$var$clone(obj) {
    if (typeof structuredClone === 'function') return structuredClone(obj);
    return JSON.parse(JSON.stringify(obj));
}
class $34d7790339015997$var$LocalJWKSet {
    constructor(jwks){
        this._cached = new WeakMap();
        if (!$34d7790339015997$var$isJWKSLike(jwks)) throw new (0, $599ac781534a947a$export$9b22c2a1e2403b8e)('JSON Web Key Set malformed');
        this._jwks = $34d7790339015997$var$clone(jwks);
    }
    async getKey(protectedHeader, token) {
        const { alg: alg, kid: kid } = {
            ...protectedHeader,
            ...token?.header
        };
        const kty = $34d7790339015997$var$getKtyFromAlg(alg);
        const candidates = this._jwks.keys.filter((jwk)=>{
            let candidate = kty === jwk.kty;
            if (candidate && typeof kid === 'string') candidate = kid === jwk.kid;
            if (candidate && typeof jwk.alg === 'string') candidate = alg === jwk.alg;
            if (candidate && typeof jwk.use === 'string') candidate = jwk.use === 'sig';
            if (candidate && Array.isArray(jwk.key_ops)) candidate = jwk.key_ops.includes('verify');
            if (candidate) switch(alg){
                case 'ES256':
                    candidate = jwk.crv === 'P-256';
                    break;
                case 'ES256K':
                    candidate = jwk.crv === 'secp256k1';
                    break;
                case 'ES384':
                    candidate = jwk.crv === 'P-384';
                    break;
                case 'ES512':
                    candidate = jwk.crv === 'P-521';
                    break;
                case 'Ed25519':
                    candidate = jwk.crv === 'Ed25519';
                    break;
                case 'EdDSA':
                    candidate = jwk.crv === 'Ed25519' || jwk.crv === 'Ed448';
                    break;
            }
            return candidate;
        });
        const { 0: jwk, length: length } = candidates;
        if (length === 0) throw new (0, $599ac781534a947a$export$3d5ed1a538bed04e)();
        if (length !== 1) {
            const error = new (0, $599ac781534a947a$export$dc036de401a5c284)();
            const { _cached: _cached } = this;
            error[Symbol.asyncIterator] = async function*() {
                for (const jwk of candidates)try {
                    yield await $34d7790339015997$var$importWithAlgCache(_cached, jwk, alg);
                } catch  {}
            };
            throw error;
        }
        return $34d7790339015997$var$importWithAlgCache(this._cached, jwk, alg);
    }
}
async function $34d7790339015997$var$importWithAlgCache(cache, jwk, alg) {
    const cached = cache.get(jwk) || cache.set(jwk, {}).get(jwk);
    if (cached[alg] === undefined) {
        const key = await (0, $d3f3b992c534ed5a$export$2b70d37b4d0b888b)({
            ...jwk,
            ext: true
        }, alg);
        if (key instanceof Uint8Array || key.type !== 'public') throw new (0, $599ac781534a947a$export$9b22c2a1e2403b8e)('JSON Web Key Set members must be public keys');
        cached[alg] = key;
    }
    return cached[alg];
}
function $34d7790339015997$export$4892abc640e5f80e(jwks) {
    const set = new $34d7790339015997$var$LocalJWKSet(jwks);
    const localJWKSet = async (protectedHeader, token)=>set.getKey(protectedHeader, token);
    Object.defineProperties(localJWKSet, {
        jwks: {
            value: ()=>$34d7790339015997$var$clone(set._jwks),
            enumerable: true,
            configurable: false,
            writable: false
        }
    });
    return localJWKSet;
}



function $3c97161a25c83f88$var$isCloudflareWorkers() {
    return typeof WebSocketPair !== 'undefined' || typeof navigator !== 'undefined' && navigator.userAgent === 'Cloudflare-Workers' || typeof EdgeRuntime !== 'undefined' && EdgeRuntime === 'vercel';
}
let $3c97161a25c83f88$var$USER_AGENT;
if (typeof navigator === 'undefined' || !navigator.userAgent?.startsWith?.('Mozilla/5.0 ')) {
    const NAME = 'jose';
    const VERSION = 'v5.10.0';
    $3c97161a25c83f88$var$USER_AGENT = `${NAME}/${VERSION}`;
}
const $3c97161a25c83f88$export$68a3c8fa6edea323 = Symbol();
function $3c97161a25c83f88$var$isFreshJwksCache(input, cacheMaxAge) {
    if (typeof input !== 'object' || input === null) return false;
    if (!('uat' in input) || typeof input.uat !== 'number' || Date.now() - input.uat >= cacheMaxAge) return false;
    if (!('jwks' in input) || !(0, $319a04fbce04ffdb$export$2e2bcd8739ae039)(input.jwks) || !Array.isArray(input.jwks.keys) || !Array.prototype.every.call(input.jwks.keys, (0, $319a04fbce04ffdb$export$2e2bcd8739ae039))) return false;
    return true;
}
class $3c97161a25c83f88$var$RemoteJWKSet {
    constructor(url, options){
        if (!(url instanceof URL)) throw new TypeError('url must be an instance of URL');
        this._url = new URL(url.href);
        this._options = {
            agent: options?.agent,
            headers: options?.headers
        };
        this._timeoutDuration = typeof options?.timeoutDuration === 'number' ? options?.timeoutDuration : 5000;
        this._cooldownDuration = typeof options?.cooldownDuration === 'number' ? options?.cooldownDuration : 30000;
        this._cacheMaxAge = typeof options?.cacheMaxAge === 'number' ? options?.cacheMaxAge : 600000;
        if (options?.[$3c97161a25c83f88$export$68a3c8fa6edea323] !== undefined) {
            this._cache = options?.[$3c97161a25c83f88$export$68a3c8fa6edea323];
            if ($3c97161a25c83f88$var$isFreshJwksCache(options?.[$3c97161a25c83f88$export$68a3c8fa6edea323], this._cacheMaxAge)) {
                this._jwksTimestamp = this._cache.uat;
                this._local = (0, $34d7790339015997$export$4892abc640e5f80e)(this._cache.jwks);
            }
        }
    }
    coolingDown() {
        return typeof this._jwksTimestamp === 'number' ? Date.now() < this._jwksTimestamp + this._cooldownDuration : false;
    }
    fresh() {
        return typeof this._jwksTimestamp === 'number' ? Date.now() < this._jwksTimestamp + this._cacheMaxAge : false;
    }
    async getKey(protectedHeader, token) {
        if (!this._local || !this.fresh()) await this.reload();
        try {
            return await this._local(protectedHeader, token);
        } catch (err) {
            if (err instanceof (0, $599ac781534a947a$export$3d5ed1a538bed04e)) {
                if (this.coolingDown() === false) {
                    await this.reload();
                    return this._local(protectedHeader, token);
                }
            }
            throw err;
        }
    }
    async reload() {
        if (this._pendingFetch && $3c97161a25c83f88$var$isCloudflareWorkers()) this._pendingFetch = undefined;
        const headers = new Headers(this._options.headers);
        if ($3c97161a25c83f88$var$USER_AGENT && !headers.has('User-Agent')) {
            headers.set('User-Agent', $3c97161a25c83f88$var$USER_AGENT);
            this._options.headers = Object.fromEntries(headers.entries());
        }
        this._pendingFetch || (this._pendingFetch = (0, $22e7f56c38b2bd5a$export$2e2bcd8739ae039)(this._url, this._timeoutDuration, this._options).then((json)=>{
            this._local = (0, $34d7790339015997$export$4892abc640e5f80e)(json);
            if (this._cache) {
                this._cache.uat = Date.now();
                this._cache.jwks = json;
            }
            this._jwksTimestamp = Date.now();
            this._pendingFetch = undefined;
        }).catch((err)=>{
            this._pendingFetch = undefined;
            throw err;
        }));
        await this._pendingFetch;
    }
}
function $3c97161a25c83f88$export$78ce35c2df51c333(url, options) {
    const set = new $3c97161a25c83f88$var$RemoteJWKSet(url, options);
    const remoteJWKSet = async (protectedHeader, token)=>set.getKey(protectedHeader, token);
    Object.defineProperties(remoteJWKSet, {
        coolingDown: {
            get: ()=>set.coolingDown(),
            enumerable: true,
            configurable: false
        },
        fresh: {
            get: ()=>set.fresh(),
            enumerable: true,
            configurable: false
        },
        reload: {
            value: ()=>set.reload(),
            enumerable: true,
            configurable: false,
            writable: false
        },
        reloading: {
            get: ()=>!!set._pendingFetch,
            enumerable: true,
            configurable: false
        },
        jwks: {
            value: ()=>set._local?.jwks(),
            enumerable: true,
            configurable: false,
            writable: false
        }
    });
    return remoteJWKSet;
}
const $3c97161a25c83f88$export$3ec5a8fe10b55ead = $3c97161a25c83f88$export$68a3c8fa6edea323;



function $fd9ff84d4ad74129$export$2e2bcd8739ae039(alg, algorithm) {
    const hash = `SHA-${alg.slice(-3)}`;
    switch(alg){
        case 'HS256':
        case 'HS384':
        case 'HS512':
            return {
                hash: hash,
                name: 'HMAC'
            };
        case 'PS256':
        case 'PS384':
        case 'PS512':
            return {
                hash: hash,
                name: 'RSA-PSS',
                saltLength: alg.slice(-3) >> 3
            };
        case 'RS256':
        case 'RS384':
        case 'RS512':
            return {
                hash: hash,
                name: 'RSASSA-PKCS1-v1_5'
            };
        case 'ES256':
        case 'ES384':
        case 'ES512':
            return {
                hash: hash,
                name: 'ECDSA',
                namedCurve: algorithm.namedCurve
            };
        case 'Ed25519':
            return {
                name: 'Ed25519'
            };
        case 'EdDSA':
            return {
                name: algorithm.name
            };
        default:
            throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)(`alg ${alg} is not supported either by JOSE or your javascript runtime`);
    }
}



var $2c8180cef663e103$export$2e2bcd8739ae039 = (alg, key)=>{
    if (alg.startsWith('RS') || alg.startsWith('PS')) {
        const { modulusLength: modulusLength } = key.algorithm;
        if (typeof modulusLength !== 'number' || modulusLength < 2048) throw new TypeError(`${alg} requires key modulusLength to be 2048 bits or larger`);
    }
};



function $bd0b36fb17abf4f5$var$unusable(name, prop = 'algorithm.name') {
    return new TypeError(`CryptoKey does not support this operation, its ${prop} must be ${name}`);
}
function $bd0b36fb17abf4f5$var$isAlgorithm(algorithm, name) {
    return algorithm.name === name;
}
function $bd0b36fb17abf4f5$var$getHashLength(hash) {
    return parseInt(hash.name.slice(4), 10);
}
function $bd0b36fb17abf4f5$var$getNamedCurve(alg) {
    switch(alg){
        case 'ES256':
            return 'P-256';
        case 'ES384':
            return 'P-384';
        case 'ES512':
            return 'P-521';
        default:
            throw new Error('unreachable');
    }
}
function $bd0b36fb17abf4f5$var$checkUsage(key, usages) {
    if (usages.length && !usages.some((expected)=>key.usages.includes(expected))) {
        let msg = 'CryptoKey does not support this operation, its usages must include ';
        if (usages.length > 2) {
            const last = usages.pop();
            msg += `one of ${usages.join(', ')}, or ${last}.`;
        } else if (usages.length === 2) msg += `one of ${usages[0]} or ${usages[1]}.`;
        else msg += `${usages[0]}.`;
        throw new TypeError(msg);
    }
}
function $bd0b36fb17abf4f5$export$39a36029eee6729(key, alg, ...usages) {
    switch(alg){
        case 'HS256':
        case 'HS384':
        case 'HS512':
            {
                if (!$bd0b36fb17abf4f5$var$isAlgorithm(key.algorithm, 'HMAC')) throw $bd0b36fb17abf4f5$var$unusable('HMAC');
                const expected = parseInt(alg.slice(2), 10);
                const actual = $bd0b36fb17abf4f5$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $bd0b36fb17abf4f5$var$unusable(`SHA-${expected}`, 'algorithm.hash');
                break;
            }
        case 'RS256':
        case 'RS384':
        case 'RS512':
            {
                if (!$bd0b36fb17abf4f5$var$isAlgorithm(key.algorithm, 'RSASSA-PKCS1-v1_5')) throw $bd0b36fb17abf4f5$var$unusable('RSASSA-PKCS1-v1_5');
                const expected = parseInt(alg.slice(2), 10);
                const actual = $bd0b36fb17abf4f5$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $bd0b36fb17abf4f5$var$unusable(`SHA-${expected}`, 'algorithm.hash');
                break;
            }
        case 'PS256':
        case 'PS384':
        case 'PS512':
            {
                if (!$bd0b36fb17abf4f5$var$isAlgorithm(key.algorithm, 'RSA-PSS')) throw $bd0b36fb17abf4f5$var$unusable('RSA-PSS');
                const expected = parseInt(alg.slice(2), 10);
                const actual = $bd0b36fb17abf4f5$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $bd0b36fb17abf4f5$var$unusable(`SHA-${expected}`, 'algorithm.hash');
                break;
            }
        case 'EdDSA':
            if (key.algorithm.name !== 'Ed25519' && key.algorithm.name !== 'Ed448') throw $bd0b36fb17abf4f5$var$unusable('Ed25519 or Ed448');
            break;
        case 'Ed25519':
            if (!$bd0b36fb17abf4f5$var$isAlgorithm(key.algorithm, 'Ed25519')) throw $bd0b36fb17abf4f5$var$unusable('Ed25519');
            break;
        case 'ES256':
        case 'ES384':
        case 'ES512':
            {
                if (!$bd0b36fb17abf4f5$var$isAlgorithm(key.algorithm, 'ECDSA')) throw $bd0b36fb17abf4f5$var$unusable('ECDSA');
                const expected = $bd0b36fb17abf4f5$var$getNamedCurve(alg);
                const actual = key.algorithm.namedCurve;
                if (actual !== expected) throw $bd0b36fb17abf4f5$var$unusable(expected, 'algorithm.namedCurve');
                break;
            }
        default:
            throw new TypeError('CryptoKey does not support this operation');
    }
    $bd0b36fb17abf4f5$var$checkUsage(key, usages);
}
function $bd0b36fb17abf4f5$export$41a67f89f6678b35(key, alg, ...usages) {
    switch(alg){
        case 'A128GCM':
        case 'A192GCM':
        case 'A256GCM':
            {
                if (!$bd0b36fb17abf4f5$var$isAlgorithm(key.algorithm, 'AES-GCM')) throw $bd0b36fb17abf4f5$var$unusable('AES-GCM');
                const expected = parseInt(alg.slice(1, 4), 10);
                const actual = key.algorithm.length;
                if (actual !== expected) throw $bd0b36fb17abf4f5$var$unusable(expected, 'algorithm.length');
                break;
            }
        case 'A128KW':
        case 'A192KW':
        case 'A256KW':
            {
                if (!$bd0b36fb17abf4f5$var$isAlgorithm(key.algorithm, 'AES-KW')) throw $bd0b36fb17abf4f5$var$unusable('AES-KW');
                const expected = parseInt(alg.slice(1, 4), 10);
                const actual = key.algorithm.length;
                if (actual !== expected) throw $bd0b36fb17abf4f5$var$unusable(expected, 'algorithm.length');
                break;
            }
        case 'ECDH':
            switch(key.algorithm.name){
                case 'ECDH':
                case 'X25519':
                case 'X448':
                    break;
                default:
                    throw $bd0b36fb17abf4f5$var$unusable('ECDH, X25519, or X448');
            }
            break;
        case 'PBES2-HS256+A128KW':
        case 'PBES2-HS384+A192KW':
        case 'PBES2-HS512+A256KW':
            if (!$bd0b36fb17abf4f5$var$isAlgorithm(key.algorithm, 'PBKDF2')) throw $bd0b36fb17abf4f5$var$unusable('PBKDF2');
            break;
        case 'RSA-OAEP':
        case 'RSA-OAEP-256':
        case 'RSA-OAEP-384':
        case 'RSA-OAEP-512':
            {
                if (!$bd0b36fb17abf4f5$var$isAlgorithm(key.algorithm, 'RSA-OAEP')) throw $bd0b36fb17abf4f5$var$unusable('RSA-OAEP');
                const expected = parseInt(alg.slice(9), 10) || 1;
                const actual = $bd0b36fb17abf4f5$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $bd0b36fb17abf4f5$var$unusable(`SHA-${expected}`, 'algorithm.hash');
                break;
            }
        default:
            throw new TypeError('CryptoKey does not support this operation');
    }
    $bd0b36fb17abf4f5$var$checkUsage(key, usages);
}





function $3eff6d14b0ca9812$export$9a44c2ef7e3b3dad(key) {
    return (0, $319a04fbce04ffdb$export$2e2bcd8739ae039)(key) && typeof key.kty === 'string';
}
function $3eff6d14b0ca9812$export$431699a4f17ba0e(key) {
    return key.kty !== 'oct' && typeof key.d === 'string';
}
function $3eff6d14b0ca9812$export$b786616db1cddf3(key) {
    return key.kty !== 'oct' && typeof key.d === 'undefined';
}
function $3eff6d14b0ca9812$export$f8ecf533504bc7ad(key) {
    return $3eff6d14b0ca9812$export$9a44c2ef7e3b3dad(key) && key.kty === 'oct' && typeof key.k === 'string';
}




const $946aa8f62005044f$var$exportKeyValue = (k)=>(0, $54a6e0e463467b0a$export$2f872c0f2117be69)(k);
let $946aa8f62005044f$var$privCache;
let $946aa8f62005044f$var$pubCache;
const $946aa8f62005044f$var$isKeyObject = (key)=>{
    return key?.[Symbol.toStringTag] === 'KeyObject';
};
const $946aa8f62005044f$var$importAndCache = async (cache, key, jwk, alg, freeze = false)=>{
    let cached = cache.get(key);
    if (cached?.[alg]) return cached[alg];
    const cryptoKey = await (0, $337343867c42a494$export$2e2bcd8739ae039)({
        ...jwk,
        alg: alg
    });
    if (freeze) Object.freeze(key);
    if (!cached) cache.set(key, {
        [alg]: cryptoKey
    });
    else cached[alg] = cryptoKey;
    return cryptoKey;
};
const $946aa8f62005044f$var$normalizePublicKey = (key, alg)=>{
    if ($946aa8f62005044f$var$isKeyObject(key)) {
        let jwk = key.export({
            format: 'jwk'
        });
        delete jwk.d;
        delete jwk.dp;
        delete jwk.dq;
        delete jwk.p;
        delete jwk.q;
        delete jwk.qi;
        if (jwk.k) return $946aa8f62005044f$var$exportKeyValue(jwk.k);
        $946aa8f62005044f$var$pubCache || ($946aa8f62005044f$var$pubCache = new WeakMap());
        return $946aa8f62005044f$var$importAndCache($946aa8f62005044f$var$pubCache, key, jwk, alg);
    }
    if ((0, $3eff6d14b0ca9812$export$9a44c2ef7e3b3dad)(key)) {
        if (key.k) return (0, $54a6e0e463467b0a$export$2f872c0f2117be69)(key.k);
        $946aa8f62005044f$var$pubCache || ($946aa8f62005044f$var$pubCache = new WeakMap());
        const cryptoKey = $946aa8f62005044f$var$importAndCache($946aa8f62005044f$var$pubCache, key, key, alg, true);
        return cryptoKey;
    }
    return key;
};
const $946aa8f62005044f$var$normalizePrivateKey = (key, alg)=>{
    if ($946aa8f62005044f$var$isKeyObject(key)) {
        let jwk = key.export({
            format: 'jwk'
        });
        if (jwk.k) return $946aa8f62005044f$var$exportKeyValue(jwk.k);
        $946aa8f62005044f$var$privCache || ($946aa8f62005044f$var$privCache = new WeakMap());
        return $946aa8f62005044f$var$importAndCache($946aa8f62005044f$var$privCache, key, jwk, alg);
    }
    if ((0, $3eff6d14b0ca9812$export$9a44c2ef7e3b3dad)(key)) {
        if (key.k) return (0, $54a6e0e463467b0a$export$2f872c0f2117be69)(key.k);
        $946aa8f62005044f$var$privCache || ($946aa8f62005044f$var$privCache = new WeakMap());
        const cryptoKey = $946aa8f62005044f$var$importAndCache($946aa8f62005044f$var$privCache, key, key, alg, true);
        return cryptoKey;
    }
    return key;
};
var $946aa8f62005044f$export$2e2bcd8739ae039 = {
    normalizePublicKey: $946aa8f62005044f$var$normalizePublicKey,
    normalizePrivateKey: $946aa8f62005044f$var$normalizePrivateKey
};


async function $dd8265016b6a4c59$export$2e2bcd8739ae039(alg, key, usage) {
    if (usage === 'sign') key = await (0, $946aa8f62005044f$export$2e2bcd8739ae039).normalizePrivateKey(key, alg);
    if (usage === 'verify') key = await (0, $946aa8f62005044f$export$2e2bcd8739ae039).normalizePublicKey(key, alg);
    if ((0, $3f0b33e7ccc65ae0$export$600b5603bbac4c6)(key)) {
        (0, $bd0b36fb17abf4f5$export$39a36029eee6729)(key, alg, usage);
        return key;
    }
    if (key instanceof Uint8Array) {
        if (!alg.startsWith('HS')) throw new TypeError((0, $233e587bc0c17441$export$2e2bcd8739ae039)(key, ...(0, $002bdc4a0215a55c$export$b14ad400b1d09e0f)));
        return (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.importKey('raw', key, {
            hash: `SHA-${alg.slice(-3)}`,
            name: 'HMAC'
        }, false, [
            usage
        ]);
    }
    throw new TypeError((0, $233e587bc0c17441$export$2e2bcd8739ae039)(key, ...(0, $002bdc4a0215a55c$export$b14ad400b1d09e0f), 'Uint8Array', 'JSON Web Key'));
}


const $dbb3eb797cbe0e44$var$verify = async (alg, key, signature, data)=>{
    const cryptoKey = await (0, $dd8265016b6a4c59$export$2e2bcd8739ae039)(alg, key, 'verify');
    (0, $2c8180cef663e103$export$2e2bcd8739ae039)(alg, cryptoKey);
    const algorithm = (0, $fd9ff84d4ad74129$export$2e2bcd8739ae039)(alg, cryptoKey.algorithm);
    try {
        return await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.verify(algorithm, cryptoKey, signature, data);
    } catch  {
        return false;
    }
};
var $dbb3eb797cbe0e44$export$2e2bcd8739ae039 = $dbb3eb797cbe0e44$var$verify;




const $751ed1ebc64f8b96$var$isDisjoint = (...headers)=>{
    const sources = headers.filter(Boolean);
    if (sources.length === 0 || sources.length === 1) return true;
    let acc;
    for (const header of sources){
        const parameters = Object.keys(header);
        if (!acc || acc.size === 0) {
            acc = new Set(parameters);
            continue;
        }
        for (const parameter of parameters){
            if (acc.has(parameter)) return false;
            acc.add(parameter);
        }
    }
    return true;
};
var $751ed1ebc64f8b96$export$2e2bcd8739ae039 = $751ed1ebc64f8b96$var$isDisjoint;






const $8a5b1565e0dee973$var$tag = (key)=>key?.[Symbol.toStringTag];
const $8a5b1565e0dee973$var$jwkMatchesOp = (alg, key, usage)=>{
    if (key.use !== undefined && key.use !== 'sig') throw new TypeError('Invalid key for this operation, when present its use must be sig');
    if (key.key_ops !== undefined && key.key_ops.includes?.(usage) !== true) throw new TypeError(`Invalid key for this operation, when present its key_ops must include ${usage}`);
    if (key.alg !== undefined && key.alg !== alg) throw new TypeError(`Invalid key for this operation, when present its alg must be ${alg}`);
    return true;
};
const $8a5b1565e0dee973$var$symmetricTypeCheck = (alg, key, usage, allowJwk)=>{
    if (key instanceof Uint8Array) return;
    if (allowJwk && $3eff6d14b0ca9812$export$9a44c2ef7e3b3dad(key)) {
        if ($3eff6d14b0ca9812$export$f8ecf533504bc7ad(key) && $8a5b1565e0dee973$var$jwkMatchesOp(alg, key, usage)) return;
        throw new TypeError(`JSON Web Key for symmetric algorithms must have JWK "kty" (Key Type) equal to "oct" and the JWK "k" (Key Value) present`);
    }
    if (!(0, $002bdc4a0215a55c$export$2e2bcd8739ae039)(key)) throw new TypeError((0, $233e587bc0c17441$export$e94f758d09bc1828)(alg, key, ...(0, $002bdc4a0215a55c$export$b14ad400b1d09e0f), 'Uint8Array', allowJwk ? 'JSON Web Key' : null));
    if (key.type !== 'secret') throw new TypeError(`${$8a5b1565e0dee973$var$tag(key)} instances for symmetric algorithms must be of type "secret"`);
};
const $8a5b1565e0dee973$var$asymmetricTypeCheck = (alg, key, usage, allowJwk)=>{
    if (allowJwk && $3eff6d14b0ca9812$export$9a44c2ef7e3b3dad(key)) switch(usage){
        case 'sign':
            if ($3eff6d14b0ca9812$export$431699a4f17ba0e(key) && $8a5b1565e0dee973$var$jwkMatchesOp(alg, key, usage)) return;
            throw new TypeError(`JSON Web Key for this operation be a private JWK`);
        case 'verify':
            if ($3eff6d14b0ca9812$export$b786616db1cddf3(key) && $8a5b1565e0dee973$var$jwkMatchesOp(alg, key, usage)) return;
            throw new TypeError(`JSON Web Key for this operation be a public JWK`);
    }
    if (!(0, $002bdc4a0215a55c$export$2e2bcd8739ae039)(key)) throw new TypeError((0, $233e587bc0c17441$export$e94f758d09bc1828)(alg, key, ...(0, $002bdc4a0215a55c$export$b14ad400b1d09e0f), allowJwk ? 'JSON Web Key' : null));
    if (key.type === 'secret') throw new TypeError(`${$8a5b1565e0dee973$var$tag(key)} instances for asymmetric algorithms must not be of type "secret"`);
    if (usage === 'sign' && key.type === 'public') throw new TypeError(`${$8a5b1565e0dee973$var$tag(key)} instances for asymmetric algorithm signing must be of type "private"`);
    if (usage === 'decrypt' && key.type === 'public') throw new TypeError(`${$8a5b1565e0dee973$var$tag(key)} instances for asymmetric algorithm decryption must be of type "private"`);
    if (key.algorithm && usage === 'verify' && key.type === 'private') throw new TypeError(`${$8a5b1565e0dee973$var$tag(key)} instances for asymmetric algorithm verifying must be of type "public"`);
    if (key.algorithm && usage === 'encrypt' && key.type === 'private') throw new TypeError(`${$8a5b1565e0dee973$var$tag(key)} instances for asymmetric algorithm encryption must be of type "public"`);
};
function $8a5b1565e0dee973$var$checkKeyType(allowJwk, alg, key, usage) {
    const symmetric = alg.startsWith('HS') || alg === 'dir' || alg.startsWith('PBES2') || /^A\d{3}(?:GCM)?KW$/.test(alg);
    if (symmetric) $8a5b1565e0dee973$var$symmetricTypeCheck(alg, key, usage, allowJwk);
    else $8a5b1565e0dee973$var$asymmetricTypeCheck(alg, key, usage, allowJwk);
}
var $8a5b1565e0dee973$export$2e2bcd8739ae039 = $8a5b1565e0dee973$var$checkKeyType.bind(undefined, false);
const $8a5b1565e0dee973$export$d7fd0dd52697ff18 = $8a5b1565e0dee973$var$checkKeyType.bind(undefined, true);



function $0b572ece71b785f0$var$validateCrit(Err, recognizedDefault, recognizedOption, protectedHeader, joseHeader) {
    if (joseHeader.crit !== undefined && protectedHeader?.crit === undefined) throw new Err('"crit" (Critical) Header Parameter MUST be integrity protected');
    if (!protectedHeader || protectedHeader.crit === undefined) return new Set();
    if (!Array.isArray(protectedHeader.crit) || protectedHeader.crit.length === 0 || protectedHeader.crit.some((input)=>typeof input !== 'string' || input.length === 0)) throw new Err('"crit" (Critical) Header Parameter MUST be an array of non-empty strings when present');
    let recognized;
    if (recognizedOption !== undefined) recognized = new Map([
        ...Object.entries(recognizedOption),
        ...recognizedDefault.entries()
    ]);
    else recognized = recognizedDefault;
    for (const parameter of protectedHeader.crit){
        if (!recognized.has(parameter)) throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)(`Extension Header Parameter "${parameter}" is not recognized`);
        if (joseHeader[parameter] === undefined) throw new Err(`Extension Header Parameter "${parameter}" is missing`);
        if (recognized.get(parameter) && protectedHeader[parameter] === undefined) throw new Err(`Extension Header Parameter "${parameter}" MUST be integrity protected`);
    }
    return new Set(protectedHeader.crit);
}
var $0b572ece71b785f0$export$2e2bcd8739ae039 = $0b572ece71b785f0$var$validateCrit;


const $33550bd8f4719411$var$validateAlgorithms = (option, algorithms)=>{
    if (algorithms !== undefined && (!Array.isArray(algorithms) || algorithms.some((s)=>typeof s !== 'string'))) throw new TypeError(`"${option}" option must be an array of strings`);
    if (!algorithms) return undefined;
    return new Set(algorithms);
};
var $33550bd8f4719411$export$2e2bcd8739ae039 = $33550bd8f4719411$var$validateAlgorithms;




async function $b1a47cad1ba554c8$export$b2614975507c40c9(jws, key, options) {
    if (!(0, $319a04fbce04ffdb$export$2e2bcd8739ae039)(jws)) throw new (0, $599ac781534a947a$export$e838de724af3d116)('Flattened JWS must be an object');
    if (jws.protected === undefined && jws.header === undefined) throw new (0, $599ac781534a947a$export$e838de724af3d116)('Flattened JWS must have either of the "protected" or "header" members');
    if (jws.protected !== undefined && typeof jws.protected !== 'string') throw new (0, $599ac781534a947a$export$e838de724af3d116)('JWS Protected Header incorrect type');
    if (jws.payload === undefined) throw new (0, $599ac781534a947a$export$e838de724af3d116)('JWS Payload missing');
    if (typeof jws.signature !== 'string') throw new (0, $599ac781534a947a$export$e838de724af3d116)('JWS Signature missing or incorrect type');
    if (jws.header !== undefined && !(0, $319a04fbce04ffdb$export$2e2bcd8739ae039)(jws.header)) throw new (0, $599ac781534a947a$export$e838de724af3d116)('JWS Unprotected Header incorrect type');
    let parsedProt = {};
    if (jws.protected) try {
        const protectedHeader = (0, $54a6e0e463467b0a$export$2f872c0f2117be69)(jws.protected);
        parsedProt = JSON.parse((0, $8c3dacf85b96b392$export$124c96e6ce37090b).decode(protectedHeader));
    } catch  {
        throw new (0, $599ac781534a947a$export$e838de724af3d116)('JWS Protected Header is invalid');
    }
    if (!(0, $751ed1ebc64f8b96$export$2e2bcd8739ae039)(parsedProt, jws.header)) throw new (0, $599ac781534a947a$export$e838de724af3d116)('JWS Protected and JWS Unprotected Header Parameter names must be disjoint');
    const joseHeader = {
        ...parsedProt,
        ...jws.header
    };
    const extensions = (0, $0b572ece71b785f0$export$2e2bcd8739ae039)((0, $599ac781534a947a$export$e838de724af3d116), new Map([
        [
            'b64',
            true
        ]
    ]), options?.crit, parsedProt, joseHeader);
    let b64 = true;
    if (extensions.has('b64')) {
        b64 = parsedProt.b64;
        if (typeof b64 !== 'boolean') throw new (0, $599ac781534a947a$export$e838de724af3d116)('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
    }
    const { alg: alg } = joseHeader;
    if (typeof alg !== 'string' || !alg) throw new (0, $599ac781534a947a$export$e838de724af3d116)('JWS "alg" (Algorithm) Header Parameter missing or invalid');
    const algorithms = options && (0, $33550bd8f4719411$export$2e2bcd8739ae039)('algorithms', options.algorithms);
    if (algorithms && !algorithms.has(alg)) throw new (0, $599ac781534a947a$export$d51fd7fedeccc338)('"alg" (Algorithm) Header Parameter value not allowed');
    if (b64) {
        if (typeof jws.payload !== 'string') throw new (0, $599ac781534a947a$export$e838de724af3d116)('JWS Payload must be a string');
    } else if (typeof jws.payload !== 'string' && !(jws.payload instanceof Uint8Array)) throw new (0, $599ac781534a947a$export$e838de724af3d116)('JWS Payload must be a string or an Uint8Array instance');
    let resolvedKey = false;
    if (typeof key === 'function') {
        key = await key(parsedProt, jws);
        resolvedKey = true;
        (0, $8a5b1565e0dee973$export$d7fd0dd52697ff18)(alg, key, 'verify');
        if ((0, $3eff6d14b0ca9812$export$9a44c2ef7e3b3dad)(key)) key = await (0, $d3f3b992c534ed5a$export$2b70d37b4d0b888b)(key, alg);
    } else (0, $8a5b1565e0dee973$export$d7fd0dd52697ff18)(alg, key, 'verify');
    const data = (0, $8c3dacf85b96b392$export$ee1b3e54f0441b22)((0, $8c3dacf85b96b392$export$5486af06137bf21a).encode(jws.protected ?? ''), (0, $8c3dacf85b96b392$export$5486af06137bf21a).encode('.'), typeof jws.payload === 'string' ? (0, $8c3dacf85b96b392$export$5486af06137bf21a).encode(jws.payload) : jws.payload);
    let signature;
    try {
        signature = (0, $54a6e0e463467b0a$export$2f872c0f2117be69)(jws.signature);
    } catch  {
        throw new (0, $599ac781534a947a$export$e838de724af3d116)('Failed to base64url decode the signature');
    }
    const verified = await (0, $dbb3eb797cbe0e44$export$2e2bcd8739ae039)(alg, key, signature, data);
    if (!verified) throw new (0, $599ac781534a947a$export$c67a0218e7c50378)();
    let payload;
    if (b64) try {
        payload = (0, $54a6e0e463467b0a$export$2f872c0f2117be69)(jws.payload);
    } catch  {
        throw new (0, $599ac781534a947a$export$e838de724af3d116)('Failed to base64url decode the payload');
    }
    else if (typeof jws.payload === 'string') payload = (0, $8c3dacf85b96b392$export$5486af06137bf21a).encode(jws.payload);
    else payload = jws.payload;
    const result = {
        payload: payload
    };
    if (jws.protected !== undefined) result.protectedHeader = parsedProt;
    if (jws.header !== undefined) result.unprotectedHeader = jws.header;
    if (resolvedKey) return {
        ...result,
        key: key
    };
    return result;
}




async function $6446add785626fa5$export$996150e72a8992e(jws, key, options) {
    if (jws instanceof Uint8Array) jws = (0, $8c3dacf85b96b392$export$124c96e6ce37090b).decode(jws);
    if (typeof jws !== 'string') throw new (0, $599ac781534a947a$export$e838de724af3d116)('Compact JWS must be a string or Uint8Array');
    const { 0: protectedHeader, 1: payload, 2: signature, length: length } = jws.split('.');
    if (length !== 3) throw new (0, $599ac781534a947a$export$e838de724af3d116)('Invalid Compact JWS');
    const verified = await (0, $b1a47cad1ba554c8$export$b2614975507c40c9)({
        payload: payload,
        protected: protectedHeader,
        signature: signature
    }, key, options);
    const result = {
        payload: verified.payload,
        protectedHeader: verified.protectedHeader
    };
    if (typeof key === 'function') return {
        ...result,
        key: verified.key
    };
    return result;
}




var $ca33ae1426f1aba8$export$2e2bcd8739ae039 = (date)=>Math.floor(date.getTime() / 1000);


const $e00eea37b383aa7e$var$minute = 60;
const $e00eea37b383aa7e$var$hour = $e00eea37b383aa7e$var$minute * 60;
const $e00eea37b383aa7e$var$day = $e00eea37b383aa7e$var$hour * 24;
const $e00eea37b383aa7e$var$week = $e00eea37b383aa7e$var$day * 7;
const $e00eea37b383aa7e$var$year = $e00eea37b383aa7e$var$day * 365.25;
const $e00eea37b383aa7e$var$REGEX = /^(\+|\-)? ?(\d+|\d+\.\d+) ?(seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)(?: (ago|from now))?$/i;
var $e00eea37b383aa7e$export$2e2bcd8739ae039 = (str)=>{
    const matched = $e00eea37b383aa7e$var$REGEX.exec(str);
    if (!matched || matched[4] && matched[1]) throw new TypeError('Invalid time period format');
    const value = parseFloat(matched[2]);
    const unit = matched[3].toLowerCase();
    let numericDate;
    switch(unit){
        case 'sec':
        case 'secs':
        case 'second':
        case 'seconds':
        case 's':
            numericDate = Math.round(value);
            break;
        case 'minute':
        case 'minutes':
        case 'min':
        case 'mins':
        case 'm':
            numericDate = Math.round(value * $e00eea37b383aa7e$var$minute);
            break;
        case 'hour':
        case 'hours':
        case 'hr':
        case 'hrs':
        case 'h':
            numericDate = Math.round(value * $e00eea37b383aa7e$var$hour);
            break;
        case 'day':
        case 'days':
        case 'd':
            numericDate = Math.round(value * $e00eea37b383aa7e$var$day);
            break;
        case 'week':
        case 'weeks':
        case 'w':
            numericDate = Math.round(value * $e00eea37b383aa7e$var$week);
            break;
        default:
            numericDate = Math.round(value * $e00eea37b383aa7e$var$year);
            break;
    }
    if (matched[1] === '-' || matched[4] === 'ago') return -numericDate;
    return numericDate;
};



const $b4d6c2e00c056d92$var$normalizeTyp = (value)=>value.toLowerCase().replace(/^application\//, '');
const $b4d6c2e00c056d92$var$checkAudiencePresence = (audPayload, audOption)=>{
    if (typeof audPayload === 'string') return audOption.includes(audPayload);
    if (Array.isArray(audPayload)) return audOption.some(Set.prototype.has.bind(new Set(audPayload)));
    return false;
};
var $b4d6c2e00c056d92$export$2e2bcd8739ae039 = (protectedHeader, encodedPayload, options = {})=>{
    let payload;
    try {
        payload = JSON.parse((0, $8c3dacf85b96b392$export$124c96e6ce37090b).decode(encodedPayload));
    } catch  {}
    if (!(0, $319a04fbce04ffdb$export$2e2bcd8739ae039)(payload)) throw new (0, $599ac781534a947a$export$936b39ada0bbfceb)('JWT Claims Set must be a top-level JSON object');
    const { typ: typ } = options;
    if (typ && (typeof protectedHeader.typ !== 'string' || $b4d6c2e00c056d92$var$normalizeTyp(protectedHeader.typ) !== $b4d6c2e00c056d92$var$normalizeTyp(typ))) throw new (0, $599ac781534a947a$export$f1e14efb908196e9)('unexpected "typ" JWT header value', payload, 'typ', 'check_failed');
    const { requiredClaims: requiredClaims = [], issuer: issuer, subject: subject, audience: audience, maxTokenAge: maxTokenAge } = options;
    const presenceCheck = [
        ...requiredClaims
    ];
    if (maxTokenAge !== undefined) presenceCheck.push('iat');
    if (audience !== undefined) presenceCheck.push('aud');
    if (subject !== undefined) presenceCheck.push('sub');
    if (issuer !== undefined) presenceCheck.push('iss');
    for (const claim of new Set(presenceCheck.reverse())){
        if (!(claim in payload)) throw new (0, $599ac781534a947a$export$f1e14efb908196e9)(`missing required "${claim}" claim`, payload, claim, 'missing');
    }
    if (issuer && !(Array.isArray(issuer) ? issuer : [
        issuer
    ]).includes(payload.iss)) throw new (0, $599ac781534a947a$export$f1e14efb908196e9)('unexpected "iss" claim value', payload, 'iss', 'check_failed');
    if (subject && payload.sub !== subject) throw new (0, $599ac781534a947a$export$f1e14efb908196e9)('unexpected "sub" claim value', payload, 'sub', 'check_failed');
    if (audience && !$b4d6c2e00c056d92$var$checkAudiencePresence(payload.aud, typeof audience === 'string' ? [
        audience
    ] : audience)) throw new (0, $599ac781534a947a$export$f1e14efb908196e9)('unexpected "aud" claim value', payload, 'aud', 'check_failed');
    let tolerance;
    switch(typeof options.clockTolerance){
        case 'string':
            tolerance = (0, $e00eea37b383aa7e$export$2e2bcd8739ae039)(options.clockTolerance);
            break;
        case 'number':
            tolerance = options.clockTolerance;
            break;
        case 'undefined':
            tolerance = 0;
            break;
        default:
            throw new TypeError('Invalid clockTolerance option type');
    }
    const { currentDate: currentDate } = options;
    const now = (0, $ca33ae1426f1aba8$export$2e2bcd8739ae039)(currentDate || new Date());
    if ((payload.iat !== undefined || maxTokenAge) && typeof payload.iat !== 'number') throw new (0, $599ac781534a947a$export$f1e14efb908196e9)('"iat" claim must be a number', payload, 'iat', 'invalid');
    if (payload.nbf !== undefined) {
        if (typeof payload.nbf !== 'number') throw new (0, $599ac781534a947a$export$f1e14efb908196e9)('"nbf" claim must be a number', payload, 'nbf', 'invalid');
        if (payload.nbf > now + tolerance) throw new (0, $599ac781534a947a$export$f1e14efb908196e9)('"nbf" claim timestamp check failed', payload, 'nbf', 'check_failed');
    }
    if (payload.exp !== undefined) {
        if (typeof payload.exp !== 'number') throw new (0, $599ac781534a947a$export$f1e14efb908196e9)('"exp" claim must be a number', payload, 'exp', 'invalid');
        if (payload.exp <= now - tolerance) throw new (0, $599ac781534a947a$export$4b386bf852b7863d)('"exp" claim timestamp check failed', payload, 'exp', 'check_failed');
    }
    if (maxTokenAge) {
        const age = now - payload.iat;
        const max = typeof maxTokenAge === 'number' ? maxTokenAge : (0, $e00eea37b383aa7e$export$2e2bcd8739ae039)(maxTokenAge);
        if (age - tolerance > max) throw new (0, $599ac781534a947a$export$4b386bf852b7863d)('"iat" claim timestamp check failed (too far in the past)', payload, 'iat', 'check_failed');
        if (age < 0 - tolerance) throw new (0, $599ac781534a947a$export$f1e14efb908196e9)('"iat" claim timestamp check failed (it should be in the past)', payload, 'iat', 'check_failed');
    }
    return payload;
};



async function $059e3a140d30ed13$export$c878fd0f8381da51(jwt, key, options) {
    const verified = await (0, $6446add785626fa5$export$996150e72a8992e)(jwt, key, options);
    if (verified.protectedHeader.crit?.includes('b64') && verified.protectedHeader.b64 === false) throw new (0, $599ac781534a947a$export$936b39ada0bbfceb)('JWTs MUST NOT use unencoded payload');
    const payload = (0, $b4d6c2e00c056d92$export$2e2bcd8739ae039)(verified.protectedHeader, verified.payload, options);
    const result = {
        payload: payload,
        protectedHeader: verified.protectedHeader
    };
    if (typeof key === 'function') return {
        ...result,
        key: verified.key
    };
    return result;
}


const $51ac3969ce15b2ce$export$c520bb07796429ec = 300; // 5 minutes
const $51ac3969ce15b2ce$export$b5b3317c8aecbcd5 = async (idToken, clientId, issuer, jwks, clockTolerance = $51ac3969ce15b2ce$export$c520bb07796429ec)=>{
    const result = await (0, $059e3a140d30ed13$export$c878fd0f8381da51)(idToken, jwks, {
        audience: clientId,
        issuer: issuer,
        clockTolerance: clockTolerance
    });
    if (Math.abs((result.payload.iat ?? 0) - Date.now() / 1000) > clockTolerance) throw new (0, $0ec0fc6822140f6b$export$ba60d77e6748b659)('id_token.invalid_iat');
};
class $51ac3969ce15b2ce$export$74fd7dca29afc16a {
    constructor(client, clockTolerance = $51ac3969ce15b2ce$export$c520bb07796429ec){
        this.client = client;
        this.clockTolerance = clockTolerance;
    }
    async verifyIdToken(idToken) {
        const { appId: appId } = this.client.logtoConfig;
        const { issuer: issuer, jwksUri: jwksUri } = await this.client.getOidcConfig();
        this.getJwtVerifyGetKey ||= (0, $3c97161a25c83f88$export$78ce35c2df51c333)(new URL(jwksUri));
        await $51ac3969ce15b2ce$export$b5b3317c8aecbcd5(idToken, appId, issuer, this.getJwtVerifyGetKey, this.clockTolerance);
    }
}




var $7572cfd1819d0558$export$ae0fd1fd1ad1c3f8;
(function(PersistKey) {
    PersistKey["IdToken"] = "idToken";
    PersistKey["RefreshToken"] = "refreshToken";
    PersistKey["AccessToken"] = "accessToken";
    PersistKey["SignInSession"] = "signInSession";
})($7572cfd1819d0558$export$ae0fd1fd1ad1c3f8 || ($7572cfd1819d0558$export$ae0fd1fd1ad1c3f8 = {}));
var $7572cfd1819d0558$export$2cb47d384c8dd787;
(function(CacheKey) {
    /**
     * OpenID Configuration endpoint response.
     *
     * @see {@link https://openid.net/specs/openid-connect-discovery-1_0.html#ProviderConfigurationResponse | OpenID Connect Discovery 1.0}
     */ CacheKey["OpenidConfig"] = "openidConfiguration";
    /**
     * The content of OpenID Provider's `jwks_uri` (JSON Web Key Set).
     *
     * @see {@link https://openid.net/specs/openid-connect-discovery-1_0-21.html#ProviderMetadata | OpenID Connect Discovery 1.0}
     */ CacheKey["Jwks"] = "jwks";
})($7572cfd1819d0558$export$2cb47d384c8dd787 || ($7572cfd1819d0558$export$2cb47d384c8dd787 = {}));


class $e2105cc1e2c3903d$export$63ca545e0fd86684 {
    /* END OF IMPLEMENTATION */ constructor(adapter){
        // eslint-disable-next-line @silverhand/fp/no-mutating-assign
        Object.assign(this, adapter);
    }
    async setStorageItem(key, value) {
        if (!value) {
            await this.storage.removeItem(key);
            return;
        }
        await this.storage.setItem(key, value);
    }
    /**
     * Try to get the string value from the cache and parse as JSON.
     * Return the parsed value if it is an object, return `undefined` otherwise.
     *
     * @param key The cache key to get value from.
     */ async getCachedObject(key) {
        const cached = await (0, $38826c6c09b4e4ad$export$a3a27526e073307)(async ()=>{
            const data = await this.unstable_cache?.getItem(key);
            // It's actually `unknown`
            // eslint-disable-next-line no-restricted-syntax
            return (0, $26adfd4e288f2886$export$c327da55a124987a)(data && JSON.parse(data));
        });
        if (cached && typeof cached === 'object') // Trust cache for now
        // eslint-disable-next-line no-restricted-syntax
        return cached;
    }
    /**
     * Try to get the value from the cache first, if it doesn't exist in cache,
     * run the getter function and store the result into cache.
     *
     * @param key The cache key to get value from.
     */ async getWithCache(key, getter) {
        const cached = await this.getCachedObject(key);
        if (cached) return cached;
        const result = await getter();
        await this.unstable_cache?.setItem(key, JSON.stringify(result));
        return result;
    }
}



const $8203e6f31a3eb74a$var$logtoClientErrorCodes = Object.freeze({
    'sign_in_session.invalid': 'Invalid sign-in session.',
    'sign_in_session.not_found': 'Sign-in session not found.',
    not_authenticated: 'Not authenticated.',
    fetch_user_info_failed: 'Unable to fetch user info. The access token may be invalid.',
    user_cancelled: 'The user cancelled the action.',
    missing_scope_organizations: `The \`${(0, $c647641c72d4ae96$export$4b02c5b431f6eb78).Organizations}\` scope is required`
});
class $8203e6f31a3eb74a$export$877962ca249b8fc8 extends Error {
    constructor(code, data){
        super($8203e6f31a3eb74a$var$logtoClientErrorCodes[code]);
        this.name = 'LogtoClientError';
        this.code = code;
        this.data = data;
    }
}




/**
 * Normalize the Logto client configuration per the following rules:
 *
 * - Add default scopes (`openid`, `offline_access` and `profile`) if not provided and
 * `includeReservedScopes` is `true`.
 * - Add {@link ReservedResource.Organization} to resources if {@link UserScope.Organizations} is
 * included in scopes.
 *
 * @param config The Logto client configuration to be normalized.
 * @returns The normalized Logto client configuration.
 */ const $1c0d9e83737383f8$export$36dfb28a0f06fe9c = (config)=>{
    const { prompt: prompt = (0, $16df83338927e1fb$export$83716a4aa1642908).Consent, scopes: scopes = [], resources: resources, ...rest } = config;
    const includeReservedScopes = config.includeReservedScopes ?? true;
    return {
        ...rest,
        prompt: prompt,
        scopes: includeReservedScopes ? (0, $b7edcde1a56281b2$export$887ed125f549a57)(scopes).split(' ') : scopes,
        resources: scopes.includes((0, $c647641c72d4ae96$export$4b02c5b431f6eb78).Organizations) ? (0, $e624b8b5360a6b17$export$6b75200e58bc97d0)([
            ...resources ?? [],
            (0, $c647641c72d4ae96$export$36ba08a8e14b2df6).Organization
        ]) : resources,
        includeReservedScopes: includeReservedScopes
    };
};
const $1c0d9e83737383f8$export$5d8adf6e063019de = (data)=>{
    if (!(0, $5071cd8c093ffe66$export$aa016a295c6092c8)(data)) return false;
    return [
        'redirectUri',
        'codeVerifier',
        'state'
    ].every((key)=>typeof data[key] === 'string');
};
const $1c0d9e83737383f8$export$c12fab42a9a3e2a6 = (data)=>{
    if (!(0, $5071cd8c093ffe66$export$aa016a295c6092c8)(data)) return false;
    return Object.values(data).every((value)=>{
        if (!(0, $5071cd8c093ffe66$export$aa016a295c6092c8)(value)) return false;
        return typeof value.token === 'string' && typeof value.scope === 'string' && typeof value.expiresAt === 'number';
    });
};




const $a814376db8658b27$export$8f595bd2a47bcea6 = (resource = '', organizationId, scopes = [])=>`${scopes.slice().sort().join(' ')}@${resource}${(0, $26adfd4e288f2886$export$78aa88a01782ee9d)(organizationId && `#${organizationId}`)}`;
const $a814376db8658b27$export$5d9c34f69c80822b = (endpoint)=>(0, $d48f1d2cad3531a6$export$c3cef1c0537c0eb2)(new URL(endpoint), (0, $351109632fb0ed83$export$815bda5ead26b243)).toString();


function $ad8a1afc8d388167$export$fc10aeed3a532e2a(run) {
    const promiseCache = new Map();
    const memoized = async function(...args) {
        const promiseKey = JSON.stringify(args);
        const cachedPromise = promiseCache.get(promiseKey);
        if (cachedPromise) return cachedPromise;
        const promise = (async ()=>{
            try {
                return await run.apply(this, args);
            } finally{
                promiseCache.delete(promiseKey);
            }
        })();
        promiseCache.set(promiseKey, promise);
        return promise;
    };
    return memoized;
}


// TODO @sijie move to essentials
/* eslint-disable @silverhand/fp/no-let */ /* eslint-disable @silverhand/fp/no-mutation */ function $b92b43e91e470189$export$d2de3aaeafa91619(function_) {
    let called = false;
    let result;
    return function(...args) {
        if (!called) {
            called = true;
            result = function_.apply(this, args);
        }
        return result;
    };
}



/* eslint-disable max-lines */ /**
 * The Logto base client class that provides the essential methods for
 * interacting with the Logto server.
 *
 * It also provides an adapter object that allows the customizations of the
 * client behavior for different environments.
 *
 * NOTE: Usually, you would use the `LogtoClient` class instead of `StandardLogtoClient` since it
 * provides the default JWT verifier. However, if you want to avoid the use of `jose` package
 * which is useful for certain environments that don't support native modules like `crypto`, you
 * can use `StandardLogtoClient` and provide your own JWT verifier.
 */ class $cb2d6c0b3218ec49$export$13350ca41f199138 {
    get jwtVerifier() {
        return this.jwtVerifierInstance;
    }
    constructor(logtoConfig, adapter, buildJwtVerifier){
        /**
         * Get the OIDC configuration from the discovery endpoint. This method will
         * only fetch the configuration once and cache the result.
         */ this.getOidcConfig = (0, $b92b43e91e470189$export$d2de3aaeafa91619)(this.#getOidcConfig);
        /**
         * Get the access token from the storage with refresh strategy.
         *
         * - If the access token has expired, it will try to fetch a new one using the Refresh Token.
         * - If there's an ongoing Promise to fetch the access token, it will return the Promise.
         *
         * If you want to get the access token claims, use {@link getAccessTokenClaims} instead.
         *
         * @param resource The resource that the access token is granted for. If not
         * specified, the access token will be used for OpenID Connect or the default
         * resource, as specified in the Logto Console.
         * @returns The access token string.
         * @throws LogtoClientError if the user is not authenticated.
         */ this.getAccessToken = (0, $ad8a1afc8d388167$export$fc10aeed3a532e2a)(this.#getAccessToken);
        /**
         * Get the access token for the specified organization from the storage with refresh strategy.
         *
         * Scope {@link UserScope.Organizations} is required in the config to use organization-related
         * methods.
         *
         * @param organizationId The ID of the organization that the access token is granted for.
         * @returns The access token string.
         * @throws LogtoClientError if the user is not authenticated.
         * @remarks
         * It uses the same refresh strategy as {@link getAccessToken}.
         */ this.getOrganizationToken = (0, $ad8a1afc8d388167$export$fc10aeed3a532e2a)(this.#getOrganizationToken);
        /**
         * Clear the access token from the cache storage.
         */ this.clearAccessToken = (0, $ad8a1afc8d388167$export$fc10aeed3a532e2a)(this.#clearAccessToken);
        /**
         * Clear all cached tokens from storage.
         */ this.clearAllTokens = (0, $ad8a1afc8d388167$export$fc10aeed3a532e2a)(this.#clearAllTokens);
        /**
         * Handle the sign-in callback by parsing the authorization code from the
         * callback URI and exchanging it for the tokens.
         *
         * @param callbackUri The callback URI, including the search params, that the user is redirected to after the sign-in flow is completed.
         * The origin and pathname of this URI must match the origin and pathname of the redirect URI specified in {@link signIn}.
         * In many cases you'll probably end up passing `window.location.href` as the argument to this function.
         * @throws LogtoClientError if the sign-in session is not found.
         */ this.handleSignInCallback = (0, $ad8a1afc8d388167$export$fc10aeed3a532e2a)(this.#handleSignInCallback);
        this.accessTokenMap = new Map();
        this.logtoConfig = (0, $1c0d9e83737383f8$export$36dfb28a0f06fe9c)(logtoConfig);
        this.adapter = new (0, $e2105cc1e2c3903d$export$63ca545e0fd86684)(adapter);
        this.jwtVerifierInstance = buildJwtVerifier(this);
        this.loadAccessTokenMap();
    }
    /**
     * Set the JWT verifier for the client.
     * @param buildJwtVerifier The JWT verifier instance or a function that returns the JWT verifier instance.
     */ setJwtVerifier(buildJwtVerifier) {
        this.jwtVerifierInstance = typeof buildJwtVerifier === 'function' ? buildJwtVerifier(this) : buildJwtVerifier;
    }
    /**
     * Check if the user is authenticated by checking if the ID token exists.
     */ async isAuthenticated() {
        return Boolean(await this.getIdToken());
    }
    /**
     * Get the Refresh Token from the storage.
     */ async getRefreshToken() {
        return this.adapter.storage.getItem('refreshToken');
    }
    /**
     * Get the ID Token from the storage. If you want to get the ID Token claims,
     * use {@link getIdTokenClaims} instead.
     */ async getIdToken() {
        return this.adapter.storage.getItem('idToken');
    }
    /**
     * Get the ID Token claims.
     */ async getIdTokenClaims() {
        const idToken = await this.getIdToken();
        if (!idToken) throw new (0, $8203e6f31a3eb74a$export$877962ca249b8fc8)('not_authenticated', 'ID token not found');
        return (0, $30fe7a95172a63a5$export$aac2d5b7f5cd16d5)(idToken);
    }
    /**
     * Get the access token claims for the specified resource.
     *
     * @param resource The resource that the access token is granted for. If not
     * specified, the access token will be used for OpenID Connect or the default
     * resource, as specified in the Logto Console.
     */ async getAccessTokenClaims(resource) {
        const accessToken = await this.getAccessToken(resource);
        return (0, $cd44eece04b021e0$export$1b57a6e65b75f5b3)(accessToken);
    }
    /**
     * Get the organization token claims for the specified organization.
     *
     * @param organizationId The ID of the organization that the access token is granted for.
     */ async getOrganizationTokenClaims(organizationId) {
        const accessToken = await this.getOrganizationToken(organizationId);
        return (0, $cd44eece04b021e0$export$1b57a6e65b75f5b3)(accessToken);
    }
    /**
     * Get the user information from the Userinfo Endpoint.
     *
     * Note the Userinfo Endpoint will return more claims than the ID Token. See
     * {@link https://docs.logto.io/docs/recipes/integrate-logto/vanilla-js/#fetch-user-information | Fetch user information}
     * for more information.
     *
     * @returns The user information.
     * @throws LogtoClientError if the user is not authenticated.
     */ async fetchUserInfo() {
        const { userinfoEndpoint: userinfoEndpoint } = await this.getOidcConfig();
        const accessToken = await this.getAccessToken();
        if (!accessToken) throw new (0, $8203e6f31a3eb74a$export$877962ca249b8fc8)('fetch_user_info_failed');
        return (0, $f01b1730f930c990$export$eee09f98e5b044aa)(userinfoEndpoint, accessToken, this.adapter.requester);
    }
    async signIn(options, mode, hint) {
        const { redirectUri: redirectUriUrl, postRedirectUri: postRedirectUriUrl, firstScreen: firstScreen, identifiers: identifiers, interactionMode: interactionMode, loginHint: loginHint, directSignIn: directSignIn, extraParams: extraParams, prompt: prompt, clearTokens: clearTokens } = typeof options === 'string' || options instanceof URL ? {
            redirectUri: options,
            postRedirectUri: undefined,
            firstScreen: undefined,
            identifiers: undefined,
            interactionMode: mode,
            loginHint: hint,
            directSignIn: undefined,
            extraParams: undefined,
            prompt: undefined,
            clearTokens: true
        } : options;
        const redirectUri = redirectUriUrl.toString();
        const postRedirectUri = postRedirectUriUrl?.toString();
        const { appId: clientId, prompt: promptViaConfig, resources: resources, scopes: scopes, includeReservedScopes: includeReservedScopes } = this.logtoConfig;
        const { authorizationEndpoint: authorizationEndpoint } = await this.getOidcConfig();
        const [codeVerifier, state] = await Promise.all([
            this.adapter.generateCodeVerifier(),
            this.adapter.generateState()
        ]);
        const codeChallenge = await this.adapter.generateCodeChallenge(codeVerifier);
        const signInUri = (0, $06c1da7f9036e9fe$export$b01a187f12b774c6)({
            authorizationEndpoint: authorizationEndpoint,
            clientId: clientId,
            redirectUri: redirectUri.toString(),
            codeChallenge: codeChallenge,
            state: state,
            scopes: scopes,
            resources: resources,
            prompt: prompt ?? promptViaConfig,
            firstScreen: firstScreen,
            identifiers: identifiers,
            interactionMode: interactionMode,
            loginHint: loginHint,
            directSignIn: directSignIn,
            extraParams: extraParams,
            includeReservedScopes: includeReservedScopes
        });
        await Promise.all([
            this.setSignInSession({
                redirectUri: redirectUri,
                postRedirectUri: postRedirectUri,
                codeVerifier: codeVerifier,
                state: state
            }),
            clearTokens === false ? undefined : this.clearAllTokens()
        ]);
        await this.adapter.navigate(signInUri, {
            redirectUri: redirectUri,
            for: 'sign-in'
        });
    }
    /**
     * Check if the user is redirected from the sign-in page by checking if the
     * current URL matches the redirect URI in the sign-in session.
     *
     * If there's no sign-in session, it will return `false`.
     *
     * @param url The current URL.
     */ async isSignInRedirected(url) {
        const signInSession = await this.getSignInSession();
        if (!signInSession) return false;
        const { redirectUri: redirectUri } = signInSession;
        const { origin: origin, pathname: pathname } = new URL(url);
        return `${origin}${pathname}` === redirectUri;
    }
    /**
     * Start the sign-out flow with the specified redirect URI. The URI must be
     * registered in the Logto Console.
     *
     * It will also revoke all the tokens and clean up the storage.
     *
     * The user will be redirected that URI after the sign-out flow is completed.
     * If the `postLogoutRedirectUri` is not specified, the user will be redirected
     * to a default page.
     */ async signOut(postLogoutRedirectUri) {
        const { appId: clientId } = this.logtoConfig;
        const { endSessionEndpoint: endSessionEndpoint, revocationEndpoint: revocationEndpoint } = await this.getOidcConfig();
        const refreshToken = await this.getRefreshToken();
        if (refreshToken) try {
            await (0, $f139cd7b1f3b1db5$export$573f8dbbf6fbef75)(revocationEndpoint, clientId, refreshToken, this.adapter.requester);
        } catch  {
        // Do nothing at this point, as we don't want to break the sign-out flow even if the revocation is failed
        }
        const url = (0, $1183c93a5ee672f0$export$b3c9a2bd2330de28)({
            endSessionEndpoint: endSessionEndpoint,
            postLogoutRedirectUri: postLogoutRedirectUri,
            clientId: clientId
        });
        await this.clearAllTokens();
        await this.adapter.navigate(url, {
            redirectUri: postLogoutRedirectUri,
            for: 'sign-out'
        });
    }
    async getSignInSession() {
        const jsonItem = await this.adapter.storage.getItem('signInSession');
        if (!jsonItem) return null;
        const item = JSON.parse(jsonItem);
        if (!(0, $1c0d9e83737383f8$export$5d8adf6e063019de)(item)) throw new (0, $8203e6f31a3eb74a$export$877962ca249b8fc8)('sign_in_session.invalid');
        return item;
    }
    async setSignInSession(value) {
        return this.adapter.setStorageItem((0, $7572cfd1819d0558$export$ae0fd1fd1ad1c3f8).SignInSession, value && JSON.stringify(value));
    }
    async setIdToken(value) {
        return this.adapter.setStorageItem((0, $7572cfd1819d0558$export$ae0fd1fd1ad1c3f8).IdToken, value);
    }
    async setRefreshToken(value) {
        return this.adapter.setStorageItem((0, $7572cfd1819d0558$export$ae0fd1fd1ad1c3f8).RefreshToken, value);
    }
    async getAccessTokenByRefreshToken(resource, organizationId) {
        const currentRefreshToken = await this.getRefreshToken();
        if (!currentRefreshToken) throw new (0, $8203e6f31a3eb74a$export$877962ca249b8fc8)('not_authenticated', 'Refresh token not found');
        const accessTokenKey = (0, $a814376db8658b27$export$8f595bd2a47bcea6)(resource, organizationId);
        const { appId: clientId } = this.logtoConfig;
        const { tokenEndpoint: tokenEndpoint } = await this.getOidcConfig();
        const requestedAt = Math.round(Date.now() / 1000);
        const { accessToken: accessToken, refreshToken: refreshToken, idToken: idToken, scope: scope, expiresIn: expiresIn } = await (0, $4671b2c4949e30aa$export$9909137b467efb8b)({
            clientId: clientId,
            tokenEndpoint: tokenEndpoint,
            refreshToken: currentRefreshToken,
            resource: resource,
            organizationId: organizationId
        }, this.adapter.requester);
        this.accessTokenMap.set(accessTokenKey, {
            token: accessToken,
            scope: scope,
            /** The `expiresAt` variable provides an approximate estimation of the actual `exp` property
             * in the token claims. It is utilized by the client to determine if the cached access token
             * has expired and when a new access token should be requested.
             */ expiresAt: requestedAt + expiresIn
        });
        await this.saveAccessTokenMap();
        if (refreshToken) await this.setRefreshToken(refreshToken);
        if (idToken) {
            await this.jwtVerifier.verifyIdToken(idToken);
            await this.setIdToken(idToken);
        }
        return accessToken;
    }
    async saveAccessTokenMap() {
        const data = {};
        for (const [key, accessToken] of this.accessTokenMap.entries())// eslint-disable-next-line @silverhand/fp/no-mutation
        data[key] = accessToken;
        await this.adapter.storage.setItem('accessToken', JSON.stringify(data));
    }
    async loadAccessTokenMap() {
        const raw = await this.adapter.storage.getItem('accessToken');
        if (!raw) return;
        try {
            const json = JSON.parse(raw);
            if (!(0, $1c0d9e83737383f8$export$c12fab42a9a3e2a6)(json)) return;
            this.accessTokenMap.clear();
            for (const [key, accessToken] of Object.entries(json))this.accessTokenMap.set(key, accessToken);
        } catch (error) {
            console.warn(error);
        }
    }
    async #getOidcConfig() {
        return this.adapter.getWithCache((0, $7572cfd1819d0558$export$2cb47d384c8dd787).OpenidConfig, async ()=>{
            return (0, $351109632fb0ed83$export$98242d8e822ad11f)((0, $a814376db8658b27$export$5d9c34f69c80822b)(this.logtoConfig.endpoint), this.adapter.requester);
        });
    }
    async #getAccessToken(resource, organizationId) {
        if (!await this.isAuthenticated()) throw new (0, $8203e6f31a3eb74a$export$877962ca249b8fc8)('not_authenticated');
        const accessTokenKey = (0, $a814376db8658b27$export$8f595bd2a47bcea6)(resource, organizationId);
        const accessToken = this.accessTokenMap.get(accessTokenKey);
        if (accessToken && accessToken.expiresAt > Date.now() / 1000) return accessToken.token;
        // Since the access token has expired, delete it from the map.
        if (accessToken) this.accessTokenMap.delete(accessTokenKey);
        /**
         * Need to fetch a new access token using refresh token.
         */ return this.getAccessTokenByRefreshToken(resource, organizationId);
    }
    async #getOrganizationToken(organizationId) {
        if (!this.logtoConfig.scopes?.includes((0, $c647641c72d4ae96$export$4b02c5b431f6eb78).Organizations)) throw new (0, $8203e6f31a3eb74a$export$877962ca249b8fc8)('missing_scope_organizations');
        return this.getAccessToken(undefined, organizationId);
    }
    async #clearAccessToken() {
        this.accessTokenMap.clear();
        await this.adapter.storage.removeItem('accessToken');
    }
    async #clearAllTokens() {
        await Promise.all([
            this.setRefreshToken(null),
            this.setIdToken(null),
            this.clearAccessToken()
        ]);
    }
    async #handleSignInCallback(callbackUri) {
        const signInSession = await this.getSignInSession();
        if (!signInSession) throw new (0, $8203e6f31a3eb74a$export$877962ca249b8fc8)('sign_in_session.not_found');
        const { redirectUri: redirectUri, postRedirectUri: postRedirectUri, state: state, codeVerifier: codeVerifier } = signInSession;
        const code = (0, $91623c234e2f4014$export$dc3fae3c99763885)(callbackUri, redirectUri, state);
        // NOTE: Will add scope to accessTokenKey when needed. (Linear issue LOG-1589)
        const accessTokenKey = (0, $a814376db8658b27$export$8f595bd2a47bcea6)();
        const { appId: clientId } = this.logtoConfig;
        const { tokenEndpoint: tokenEndpoint } = await this.getOidcConfig();
        const requestedAt = Math.round(Date.now() / 1000);
        const { idToken: idToken, refreshToken: refreshToken, accessToken: accessToken, scope: scope, expiresIn: expiresIn } = await (0, $4671b2c4949e30aa$export$684f740cd70532d4)({
            clientId: clientId,
            tokenEndpoint: tokenEndpoint,
            redirectUri: redirectUri,
            codeVerifier: codeVerifier,
            code: code
        }, this.adapter.requester);
        await this.jwtVerifier.verifyIdToken(idToken);
        await this.setRefreshToken(refreshToken ?? null);
        await this.setIdToken(idToken);
        this.accessTokenMap.set(accessTokenKey, {
            token: accessToken,
            scope: scope,
            /** The `expiresAt` variable provides an approximate estimation of the actual `exp` property
             * in the token claims. It is utilized by the client to determine if the cached access token
             * has expired and when a new access token should be requested.
             */ expiresAt: requestedAt + expiresIn
        });
        await this.saveAccessTokenMap();
        await this.setSignInSession(null);
        if (postRedirectUri) await this.adapter.navigate(postRedirectUri, {
            for: 'post-sign-in'
        });
    }
}







/**
 * A factory function that creates a requester by accepting a `fetch`-like function.
 *
 * @param fetchFunction A `fetch`-like function.
 * @returns A requester function.
 * @see {@link Requester}
 */ const $8f52988160102e9f$export$8d54726fdbf08e0a = (fetchFunction)=>{
    return async (...args)=>{
        const response = await fetchFunction(...args);
        if (!response.ok) {
            const cloned = response.clone();
            const responseJson = await response.json();
            console.error(`Logto requester error: [status=${response.status}]`, responseJson);
            if (!(0, $0ec0fc6822140f6b$export$4bc3e79991b9e2d4)(responseJson)) throw new (0, $0ec0fc6822140f6b$export$ba60d77e6748b659)('unexpected_response_error', responseJson);
            // Expected request error from server
            const { code: code, message: message } = responseJson;
            throw new (0, $0ec0fc6822140f6b$export$e6e15b8ba42b9b70)(code, message, cloned);
        }
        return response.json();
    };
};



/**
 * The Logto base client class that provides the essential methods for
 * interacting with the Logto server.
 *
 * It also provides an adapter object that allows the customizations of the
 * client behavior for different environments.
 */ class $1be15597130072aa$export$2e2bcd8739ae039 extends (0, $cb2d6c0b3218ec49$export$13350ca41f199138) {
    constructor(logtoConfig, adapter, buildJwtVerifier){
        super(logtoConfig, adapter, buildJwtVerifier ?? ((client)=>new (0, $51ac3969ce15b2ce$export$74fd7dca29afc16a)(client)));
    }
}



const $5f50672b09c2f806$var$keyPrefix = `logto_cache`;
class $5f50672b09c2f806$export$2b715f8922748263 {
    constructor(appId){
        this.appId = appId;
    }
    getKey(item) {
        if (item === undefined) return `${$5f50672b09c2f806$var$keyPrefix}:${this.appId}`;
        return `${$5f50672b09c2f806$var$keyPrefix}:${this.appId}:${item}`;
    }
    async getItem(key) {
        return sessionStorage.getItem(this.getKey(key));
    }
    async setItem(key, value) {
        sessionStorage.setItem(this.getKey(key), value);
    }
    async removeItem(key) {
        sessionStorage.removeItem(`${this.getKey(key)}`);
    }
}


const $84653a3a73251ed1$var$keyPrefix = `logto`;
class $84653a3a73251ed1$export$2baa60fa09b100be {
    constructor(appId){
        this.appId = appId;
    }
    getKey(item) {
        if (item === undefined) return `${$84653a3a73251ed1$var$keyPrefix}:${this.appId}`;
        return `${$84653a3a73251ed1$var$keyPrefix}:${this.appId}:${item}`;
    }
    async getItem(key) {
        // Make it compatible with server side, usually used in SSR, in which `null` is acceptable.
        if (typeof window === 'undefined') return null;
        if (key === 'signInSession') // The latter `getItem()` is for backward compatibility. Can be removed when major bump.
        return sessionStorage.getItem(this.getKey(key)) ?? sessionStorage.getItem(this.getKey());
        return localStorage.getItem(this.getKey(key));
    }
    async setItem(key, value) {
        // Make it compatible with server side, ignore it if it's not in browser.
        if (typeof window === 'undefined') return;
        if (key === 'signInSession') {
            sessionStorage.setItem(this.getKey(key), value);
            return;
        }
        localStorage.setItem(this.getKey(key), value);
    }
    async removeItem(key) {
        // Make it compatible with server side, ignore it if it's not in browser.
        if (typeof window === 'undefined') return;
        if (key === 'signInSession') {
            sessionStorage.removeItem(this.getKey(key));
            return;
        }
        localStorage.removeItem(this.getKey(key));
    }
}



/**
 *  base64.ts
 *
 *  Licensed under the BSD 3-Clause License.
 *    http://opensource.org/licenses/BSD-3-Clause
 *
 *  References:
 *    http://en.wikipedia.org/wiki/Base64
 *
 * @author Dan Kogai (https://github.com/dankogai)
 */ /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $7ca0d9e2d8e201da$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
const $7ca0d9e2d8e201da$export$83d89fbfd8236492 = '3.7.8';
/**
 * @deprecated use lowercase `version`.
 */ const $7ca0d9e2d8e201da$export$a4ad2735b021c132 = $7ca0d9e2d8e201da$export$83d89fbfd8236492;
const $7ca0d9e2d8e201da$var$_hasBuffer = typeof $7ca0d9e2d8e201da$require$Buffer === 'function';
const $7ca0d9e2d8e201da$var$_TD = typeof TextDecoder === 'function' ? new TextDecoder() : undefined;
const $7ca0d9e2d8e201da$var$_TE = typeof TextEncoder === 'function' ? new TextEncoder() : undefined;
const $7ca0d9e2d8e201da$var$b64ch = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
const $7ca0d9e2d8e201da$var$b64chs = Array.prototype.slice.call($7ca0d9e2d8e201da$var$b64ch);
const $7ca0d9e2d8e201da$var$b64tab = ((a)=>{
    let tab = {};
    a.forEach((c, i)=>tab[c] = i);
    return tab;
})($7ca0d9e2d8e201da$var$b64chs);
const $7ca0d9e2d8e201da$var$b64re = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/;
const $7ca0d9e2d8e201da$var$_fromCC = String.fromCharCode.bind(String);
const $7ca0d9e2d8e201da$var$_U8Afrom = typeof Uint8Array.from === 'function' ? Uint8Array.from.bind(Uint8Array) : (it)=>new Uint8Array(Array.prototype.slice.call(it, 0));
const $7ca0d9e2d8e201da$var$_mkUriSafe = (src)=>src.replace(/=/g, '').replace(/[+\/]/g, (m0)=>m0 == '+' ? '-' : '_');
const $7ca0d9e2d8e201da$var$_tidyB64 = (s)=>s.replace(/[^A-Za-z0-9\+\/]/g, '');
/**
 * polyfill version of `btoa`
 */ const $7ca0d9e2d8e201da$export$ec0fb543302ee251 = (bin)=>{
    // console.log('polyfilled');
    let u32, c0, c1, c2, asc = '';
    const pad = bin.length % 3;
    for(let i = 0; i < bin.length;){
        if ((c0 = bin.charCodeAt(i++)) > 255 || (c1 = bin.charCodeAt(i++)) > 255 || (c2 = bin.charCodeAt(i++)) > 255) throw new TypeError('invalid character found');
        u32 = c0 << 16 | c1 << 8 | c2;
        asc += $7ca0d9e2d8e201da$var$b64chs[u32 >> 18 & 63] + $7ca0d9e2d8e201da$var$b64chs[u32 >> 12 & 63] + $7ca0d9e2d8e201da$var$b64chs[u32 >> 6 & 63] + $7ca0d9e2d8e201da$var$b64chs[u32 & 63];
    }
    return pad ? asc.slice(0, pad - 3) + "===".substring(pad) : asc;
};
/**
 * does what `window.btoa` of web browsers do.
 * @param {String} bin binary string
 * @returns {string} Base64-encoded string
 */ const $7ca0d9e2d8e201da$export$a32219e24f8d1e2 = typeof btoa === 'function' ? (bin)=>btoa(bin) : $7ca0d9e2d8e201da$var$_hasBuffer ? (bin)=>$7ca0d9e2d8e201da$require$Buffer.from(bin, 'binary').toString('base64') : $7ca0d9e2d8e201da$export$ec0fb543302ee251;
const $7ca0d9e2d8e201da$var$_fromUint8Array = $7ca0d9e2d8e201da$var$_hasBuffer ? (u8a)=>$7ca0d9e2d8e201da$require$Buffer.from(u8a).toString('base64') : (u8a)=>{
    // cf. https://stackoverflow.com/questions/12710001/how-to-convert-uint8-array-to-base64-encoded-string/12713326#12713326
    const maxargs = 0x1000;
    let strs = [];
    for(let i = 0, l = u8a.length; i < l; i += maxargs)strs.push($7ca0d9e2d8e201da$var$_fromCC.apply(null, u8a.subarray(i, i + maxargs)));
    return $7ca0d9e2d8e201da$export$a32219e24f8d1e2(strs.join(''));
};
/**
 * converts a Uint8Array to a Base64 string.
 * @param {boolean} [urlsafe] URL-and-filename-safe a la RFC4648 §5
 * @returns {string} Base64 string
 */ const $7ca0d9e2d8e201da$export$27bbb4e040978768 = (u8a, urlsafe = false)=>urlsafe ? $7ca0d9e2d8e201da$var$_mkUriSafe($7ca0d9e2d8e201da$var$_fromUint8Array(u8a)) : $7ca0d9e2d8e201da$var$_fromUint8Array(u8a);
// This trick is found broken https://github.com/dankogai/js-base64/issues/130
// const utob = (src: string) => unescape(encodeURIComponent(src));
// reverting good old fationed regexp
const $7ca0d9e2d8e201da$var$cb_utob = (c)=>{
    if (c.length < 2) {
        var cc = c.charCodeAt(0);
        return cc < 0x80 ? c : cc < 0x800 ? $7ca0d9e2d8e201da$var$_fromCC(0xc0 | cc >>> 6) + $7ca0d9e2d8e201da$var$_fromCC(0x80 | cc & 0x3f) : $7ca0d9e2d8e201da$var$_fromCC(0xe0 | cc >>> 12 & 0x0f) + $7ca0d9e2d8e201da$var$_fromCC(0x80 | cc >>> 6 & 0x3f) + $7ca0d9e2d8e201da$var$_fromCC(0x80 | cc & 0x3f);
    } else {
        var cc = 0x10000 + (c.charCodeAt(0) - 0xD800) * 0x400 + (c.charCodeAt(1) - 0xDC00);
        return $7ca0d9e2d8e201da$var$_fromCC(0xf0 | cc >>> 18 & 0x07) + $7ca0d9e2d8e201da$var$_fromCC(0x80 | cc >>> 12 & 0x3f) + $7ca0d9e2d8e201da$var$_fromCC(0x80 | cc >>> 6 & 0x3f) + $7ca0d9e2d8e201da$var$_fromCC(0x80 | cc & 0x3f);
    }
};
const $7ca0d9e2d8e201da$var$re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
/**
 * @deprecated should have been internal use only.
 * @param {string} src UTF-8 string
 * @returns {string} UTF-16 string
 */ const $7ca0d9e2d8e201da$export$10d4b9bd20a66b0 = (u)=>u.replace($7ca0d9e2d8e201da$var$re_utob, $7ca0d9e2d8e201da$var$cb_utob);
//
const $7ca0d9e2d8e201da$var$_encode = $7ca0d9e2d8e201da$var$_hasBuffer ? (s)=>$7ca0d9e2d8e201da$require$Buffer.from(s, 'utf8').toString('base64') : $7ca0d9e2d8e201da$var$_TE ? (s)=>$7ca0d9e2d8e201da$var$_fromUint8Array($7ca0d9e2d8e201da$var$_TE.encode(s)) : (s)=>$7ca0d9e2d8e201da$export$a32219e24f8d1e2($7ca0d9e2d8e201da$export$10d4b9bd20a66b0(s));
/**
 * converts a UTF-8-encoded string to a Base64 string.
 * @param {boolean} [urlsafe] if `true` make the result URL-safe
 * @returns {string} Base64 string
 */ const $7ca0d9e2d8e201da$export$37cc283d8fbd3462 = (src, urlsafe = false)=>urlsafe ? $7ca0d9e2d8e201da$var$_mkUriSafe($7ca0d9e2d8e201da$var$_encode(src)) : $7ca0d9e2d8e201da$var$_encode(src);
/**
 * converts a UTF-8-encoded string to URL-safe Base64 RFC4648 §5.
 * @returns {string} Base64 string
 */ const $7ca0d9e2d8e201da$export$90c31d5baa78df44 = (src)=>$7ca0d9e2d8e201da$export$37cc283d8fbd3462(src, true);
// This trick is found broken https://github.com/dankogai/js-base64/issues/130
// const btou = (src: string) => decodeURIComponent(escape(src));
// reverting good old fationed regexp
const $7ca0d9e2d8e201da$var$re_btou = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g;
const $7ca0d9e2d8e201da$var$cb_btou = (cccc)=>{
    switch(cccc.length){
        case 4:
            var cp = (0x07 & cccc.charCodeAt(0)) << 18 | (0x3f & cccc.charCodeAt(1)) << 12 | (0x3f & cccc.charCodeAt(2)) << 6 | 0x3f & cccc.charCodeAt(3), offset = cp - 0x10000;
            return $7ca0d9e2d8e201da$var$_fromCC((offset >>> 10) + 0xD800) + $7ca0d9e2d8e201da$var$_fromCC((offset & 0x3FF) + 0xDC00);
        case 3:
            return $7ca0d9e2d8e201da$var$_fromCC((0x0f & cccc.charCodeAt(0)) << 12 | (0x3f & cccc.charCodeAt(1)) << 6 | 0x3f & cccc.charCodeAt(2));
        default:
            return $7ca0d9e2d8e201da$var$_fromCC((0x1f & cccc.charCodeAt(0)) << 6 | 0x3f & cccc.charCodeAt(1));
    }
};
/**
 * @deprecated should have been internal use only.
 * @param {string} src UTF-16 string
 * @returns {string} UTF-8 string
 */ const $7ca0d9e2d8e201da$export$67e9defdeac3dd95 = (b)=>b.replace($7ca0d9e2d8e201da$var$re_btou, $7ca0d9e2d8e201da$var$cb_btou);
/**
 * polyfill version of `atob`
 */ const $7ca0d9e2d8e201da$export$7f16d8e674ddec24 = (asc)=>{
    // console.log('polyfilled');
    asc = asc.replace(/\s+/g, '');
    if (!$7ca0d9e2d8e201da$var$b64re.test(asc)) throw new TypeError('malformed base64.');
    asc += '=='.slice(2 - (asc.length & 3));
    let u24, r1, r2;
    let binArray = []; // use array to avoid minor gc in loop
    for(let i = 0; i < asc.length;){
        u24 = $7ca0d9e2d8e201da$var$b64tab[asc.charAt(i++)] << 18 | $7ca0d9e2d8e201da$var$b64tab[asc.charAt(i++)] << 12 | (r1 = $7ca0d9e2d8e201da$var$b64tab[asc.charAt(i++)]) << 6 | (r2 = $7ca0d9e2d8e201da$var$b64tab[asc.charAt(i++)]);
        if (r1 === 64) binArray.push($7ca0d9e2d8e201da$var$_fromCC(u24 >> 16 & 255));
        else if (r2 === 64) binArray.push($7ca0d9e2d8e201da$var$_fromCC(u24 >> 16 & 255, u24 >> 8 & 255));
        else binArray.push($7ca0d9e2d8e201da$var$_fromCC(u24 >> 16 & 255, u24 >> 8 & 255, u24 & 255));
    }
    return binArray.join('');
};
/**
 * does what `window.atob` of web browsers do.
 * @param {String} asc Base64-encoded string
 * @returns {string} binary string
 */ const $7ca0d9e2d8e201da$export$1406ac7a6dfd7b7a = typeof atob === 'function' ? (asc)=>atob($7ca0d9e2d8e201da$var$_tidyB64(asc)) : $7ca0d9e2d8e201da$var$_hasBuffer ? (asc)=>$7ca0d9e2d8e201da$require$Buffer.from(asc, 'base64').toString('binary') : $7ca0d9e2d8e201da$export$7f16d8e674ddec24;
//
const $7ca0d9e2d8e201da$var$_toUint8Array = $7ca0d9e2d8e201da$var$_hasBuffer ? (a)=>$7ca0d9e2d8e201da$var$_U8Afrom($7ca0d9e2d8e201da$require$Buffer.from(a, 'base64')) : (a)=>$7ca0d9e2d8e201da$var$_U8Afrom($7ca0d9e2d8e201da$export$1406ac7a6dfd7b7a(a).split('').map((c)=>c.charCodeAt(0)));
/**
 * converts a Base64 string to a Uint8Array.
 */ const $7ca0d9e2d8e201da$export$73470fd2221e6aef = (a)=>$7ca0d9e2d8e201da$var$_toUint8Array($7ca0d9e2d8e201da$var$_unURI(a));
//
const $7ca0d9e2d8e201da$var$_decode = $7ca0d9e2d8e201da$var$_hasBuffer ? (a)=>$7ca0d9e2d8e201da$require$Buffer.from(a, 'base64').toString('utf8') : $7ca0d9e2d8e201da$var$_TD ? (a)=>$7ca0d9e2d8e201da$var$_TD.decode($7ca0d9e2d8e201da$var$_toUint8Array(a)) : (a)=>$7ca0d9e2d8e201da$export$67e9defdeac3dd95($7ca0d9e2d8e201da$export$1406ac7a6dfd7b7a(a));
const $7ca0d9e2d8e201da$var$_unURI = (a)=>$7ca0d9e2d8e201da$var$_tidyB64(a.replace(/[-_]/g, (m0)=>m0 == '-' ? '+' : '/'));
/**
 * converts a Base64 string to a UTF-8 string.
 * @param {String} src Base64 string.  Both normal and URL-safe are supported
 * @returns {string} UTF-8 string
 */ const $7ca0d9e2d8e201da$export$c537b38001c583b7 = (src)=>$7ca0d9e2d8e201da$var$_decode($7ca0d9e2d8e201da$var$_unURI(src));
/**
 * check if a value is a valid Base64 string
 * @param {String} src a value to check
  */ const $7ca0d9e2d8e201da$export$1ea939691cdc45b8 = (src)=>{
    if (typeof src !== 'string') return false;
    const s = src.replace(/\s+/g, '').replace(/={0,2}$/, '');
    return !/[^\s0-9a-zA-Z\+/]/.test(s) || !/[^\s0-9a-zA-Z\-_]/.test(s);
};
//
const $7ca0d9e2d8e201da$var$_noEnum = (v)=>{
    return {
        value: v,
        enumerable: false,
        writable: true,
        configurable: true
    };
};
/**
 * extend String.prototype with relevant methods
 */ const $7ca0d9e2d8e201da$export$4678ebf2295c49b = function() {
    const _add = (name, body)=>Object.defineProperty(String.prototype, name, $7ca0d9e2d8e201da$var$_noEnum(body));
    _add('fromBase64', function() {
        return $7ca0d9e2d8e201da$export$c537b38001c583b7(this);
    });
    _add('toBase64', function(urlsafe) {
        return $7ca0d9e2d8e201da$export$37cc283d8fbd3462(this, urlsafe);
    });
    _add('toBase64URI', function() {
        return $7ca0d9e2d8e201da$export$37cc283d8fbd3462(this, true);
    });
    _add('toBase64URL', function() {
        return $7ca0d9e2d8e201da$export$37cc283d8fbd3462(this, true);
    });
    _add('toUint8Array', function() {
        return $7ca0d9e2d8e201da$export$73470fd2221e6aef(this);
    });
};
/**
 * extend Uint8Array.prototype with relevant methods
 */ const $7ca0d9e2d8e201da$export$a105d6a15258bd2 = function() {
    const _add = (name, body)=>Object.defineProperty(Uint8Array.prototype, name, $7ca0d9e2d8e201da$var$_noEnum(body));
    _add('toBase64', function(urlsafe) {
        return $7ca0d9e2d8e201da$export$27bbb4e040978768(this, urlsafe);
    });
    _add('toBase64URI', function() {
        return $7ca0d9e2d8e201da$export$27bbb4e040978768(this, true);
    });
    _add('toBase64URL', function() {
        return $7ca0d9e2d8e201da$export$27bbb4e040978768(this, true);
    });
};
/**
 * extend Builtin prototypes with relevant methods
 */ const $7ca0d9e2d8e201da$export$1abf1fe5ebfd5245 = ()=>{
    $7ca0d9e2d8e201da$export$4678ebf2295c49b();
    $7ca0d9e2d8e201da$export$a105d6a15258bd2();
};
const $7ca0d9e2d8e201da$export$f436b0c2107cbd35 = {
    version: $7ca0d9e2d8e201da$export$83d89fbfd8236492,
    VERSION: $7ca0d9e2d8e201da$export$a4ad2735b021c132,
    atob: $7ca0d9e2d8e201da$export$1406ac7a6dfd7b7a,
    atobPolyfill: $7ca0d9e2d8e201da$export$7f16d8e674ddec24,
    btoa: $7ca0d9e2d8e201da$export$a32219e24f8d1e2,
    btoaPolyfill: $7ca0d9e2d8e201da$export$ec0fb543302ee251,
    fromBase64: $7ca0d9e2d8e201da$export$c537b38001c583b7,
    toBase64: $7ca0d9e2d8e201da$export$37cc283d8fbd3462,
    encode: $7ca0d9e2d8e201da$export$37cc283d8fbd3462,
    encodeURI: $7ca0d9e2d8e201da$export$90c31d5baa78df44,
    encodeURL: $7ca0d9e2d8e201da$export$90c31d5baa78df44,
    utob: $7ca0d9e2d8e201da$export$10d4b9bd20a66b0,
    btou: $7ca0d9e2d8e201da$export$67e9defdeac3dd95,
    decode: $7ca0d9e2d8e201da$export$c537b38001c583b7,
    isValid: $7ca0d9e2d8e201da$export$1ea939691cdc45b8,
    fromUint8Array: $7ca0d9e2d8e201da$export$27bbb4e040978768,
    toUint8Array: $7ca0d9e2d8e201da$export$73470fd2221e6aef,
    extendString: $7ca0d9e2d8e201da$export$4678ebf2295c49b,
    extendUint8Array: $7ca0d9e2d8e201da$export$a105d6a15258bd2,
    extendBuiltins: $7ca0d9e2d8e201da$export$1abf1fe5ebfd5245
};


/** @link [Proof Key for Code Exchange by OAuth Public Clients](https://datatracker.ietf.org/doc/html/rfc7636) */ /**
 * @param length The length of the raw random data.
 */ const $37c6928182b2ae9f$var$generateRandomString = (length = 64)=>(0, $7ca0d9e2d8e201da$export$27bbb4e040978768)(crypto.getRandomValues(new Uint8Array(length)), true);
/**
 * Generates random string for state and encodes them in url safe base64
 */ const $37c6928182b2ae9f$export$9ccd2716e53a229b = ()=>$37c6928182b2ae9f$var$generateRandomString();
/**
 * Generates code verifier
 *
 * @link [Client Creates a Code Verifier](https://datatracker.ietf.org/doc/html/rfc7636#section-4.1)
 */ const $37c6928182b2ae9f$export$cf1891f923f5943a = ()=>$37c6928182b2ae9f$var$generateRandomString();
/**
 * Calculates the S256 PKCE code challenge for an arbitrary code verifier and encodes it in url safe base64
 *
 * @param {String} codeVerifier Code verifier to calculate the S256 code challenge for
 * @link [Client Creates the Code Challenge](https://datatracker.ietf.org/doc/html/rfc7636#section-4.2)
 */ const $37c6928182b2ae9f$export$414b01b1f867308a = async (codeVerifier)=>{
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (crypto.subtle === undefined) /**
         * `crypto.subtle` is available only in secure contexts (HTTPS) in some or all supporting browsers,
         * https://developer.mozilla.org/en-US/docs/Web/API/Crypto/subtle
         * https://www.chromium.org/blink/webcrypto/#accessing-it
         */ throw new (0, $0ec0fc6822140f6b$export$ba60d77e6748b659)('crypto_subtle_unavailable');
    const encodedCodeVerifier = new TextEncoder().encode(codeVerifier);
    const codeChallenge = new Uint8Array(await crypto.subtle.digest('SHA-256', encodedCodeVerifier));
    return (0, $7ca0d9e2d8e201da$export$27bbb4e040978768)(codeChallenge, true);
};


const $fd33306c4e2fc8e0$var$navigate = (url)=>{
    window.location.assign(url);
};
class $fd33306c4e2fc8e0$export$2e2bcd8739ae039 extends (0, $1be15597130072aa$export$2e2bcd8739ae039) {
    /**
     * @param config The configuration object for the client.
     * @param [unstable_enableCache=false] Whether to enable cache for well-known data.
     * Use sessionStorage by default.
     */ constructor(config, unstable_enableCache = false){
        const requester = (0, $8f52988160102e9f$export$8d54726fdbf08e0a)(fetch);
        super(config, {
            requester: requester,
            navigate: $fd33306c4e2fc8e0$var$navigate,
            storage: new (0, $84653a3a73251ed1$export$2baa60fa09b100be)(config.appId),
            unstable_cache: (0, $26adfd4e288f2886$export$c327da55a124987a)(unstable_enableCache && new (0, $5f50672b09c2f806$export$2b715f8922748263)(config.appId)),
            generateCodeChallenge: $37c6928182b2ae9f$export$414b01b1f867308a,
            generateCodeVerifier: $37c6928182b2ae9f$export$cf1891f923f5943a,
            generateState: $37c6928182b2ae9f$export$9ccd2716e53a229b
        });
    }
}


const $e73bf42412feb220$var$logtoClient = new (0, $fd33306c4e2fc8e0$export$2e2bcd8739ae039)({
    endpoint: "https://auth.meldelo.com/",
    appId: "qt97u7ubokouuk3vi0xpo"
});
const $e73bf42412feb220$var$header_cta = document.getElementById("header_cta");
const $e73bf42412feb220$var$footer_cta = document.getElementById("footer_cta");
const $e73bf42412feb220$var$hero_cta = document.getElementById("hero_cta");
const $e73bf42412feb220$var$start_trial_pro = document.getElementById("start_trial_pro");
const $e73bf42412feb220$var$start_trial_ent = document.getElementById("start_trial_ent");
const $e73bf42412feb220$var$start_now_free = document.getElementById("start_now_free");
var $e73bf42412feb220$var$toggleOpen = document.getElementById("toggleOpen");
var $e73bf42412feb220$var$toggleClose = document.getElementById("toggleClose");
var $e73bf42412feb220$var$collapseMenu = document.getElementById("collapseMenu");
function $e73bf42412feb220$var$handleClick() {
    if ($e73bf42412feb220$var$collapseMenu.style.display === "block") $e73bf42412feb220$var$collapseMenu.style.display = "none";
    else $e73bf42412feb220$var$collapseMenu.style.display = "block";
}
$e73bf42412feb220$var$toggleOpen.addEventListener("click", $e73bf42412feb220$var$handleClick);
$e73bf42412feb220$var$toggleClose.addEventListener("click", $e73bf42412feb220$var$handleClick);
const $e73bf42412feb220$var$signUp = ()=>{
    $e73bf42412feb220$var$logtoClient.signIn({
        redirectUri: "https://app.meldelo.com/",
        firstScreen: "register"
    });
};
$e73bf42412feb220$var$header_cta.addEventListener("click", $e73bf42412feb220$var$signUp);
$e73bf42412feb220$var$hero_cta.addEventListener("click", $e73bf42412feb220$var$signUp);
$e73bf42412feb220$var$footer_cta?.addEventListener("click", $e73bf42412feb220$var$signUp);
$e73bf42412feb220$var$start_trial_pro?.addEventListener("click", $e73bf42412feb220$var$signUp);
$e73bf42412feb220$var$start_trial_ent?.addEventListener("click", $e73bf42412feb220$var$signUp);
$e73bf42412feb220$var$start_now_free?.addEventListener("click", $e73bf42412feb220$var$signUp);


//# sourceMappingURL=waitlist.3ac50243.js.map
